"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4967],{

/***/ 35080:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(11527);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(50959);


function AlertDanger(param) {
    var message = param.message;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "w-full py-2 px-2 rounded-md bg-redAlertBg border border-redAlertBorder",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "flex items-center justify-start",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
                        width: "24",
                        height: "25",
                        viewBox: "0 0 24 25",
                        fill: "none",
                        xmlns: "http://www.w3.org/2000/svg",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                            d: "M12 22.5C6.477 22.5 2 18.023 2 12.5C2 6.977 6.477 2.5 12 2.5C17.523 2.5 22 6.977 22 12.5C22 18.023 17.523 22.5 12 22.5ZM11 15.5V17.5H13V15.5H11ZM11 7.5V13.5H13V7.5H11Z",
                            fill: "#FF433D"
                        })
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "ml-3",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                            className: "text-discountRed font-semibold",
                            children: "Hata"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                            className: "text-xs",
                            children: message
                        })
                    ]
                })
            ]
        })
    });
}
/* harmony default export */ __webpack_exports__["Z"] = (AlertDanger);


/***/ }),

/***/ 43055:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(11527);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(50959);


function IconTextBox(param) {
    var labelName = param.labelName, inputName = param.inputName, type = param.type, placeholder = param.placeholder, iconChange = param.iconChange, textBoxIcon = param.textBoxIcon, textBoxSecondIcon = param.textBoxSecondIcon, innerRef = param.innerRef, value = param.value, onChange = param.onChange;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), changeIcon = ref[0], setChangeIcon = ref[1];
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "flex flex-col mt-5 lg:mt-0",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("label", {
                className: "mb-1",
                children: labelName
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "flex relative items-center w-full",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", {
                        ref: innerRef,
                        value: value && value,
                        onChange: function(e) {
                            onChange && onChange(e.target.value);
                        },
                        className: "px-3 py-2 w-full rounded-md border-2 border-makdosSecondaryGray focus:outline-none focus:border-transparent focus:ring-1 focus:ring-makdosYellow",
                        type: iconChange && !changeIcon ? type : "text",
                        name: inputName,
                        placeholder: placeholder
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        onClick: function() {
                            return setChangeIcon(!changeIcon);
                        },
                        className: "flex absolute right-0 justify-center py-2 w-12 rounded-md rounded-l-none cursor-pointer",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "mr-2 w-0.5 h-5 bg-makdosSecondaryGray"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("i", {
                                className: (iconChange ? changeIcon ? textBoxIcon : textBoxSecondIcon : textBoxIcon) + " text-textGray"
                            })
                        ]
                    })
                ]
            })
        ]
    });
}
/* harmony default export */ __webpack_exports__["Z"] = (IconTextBox);


/***/ }),

/***/ 88643:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(11527);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(50959);


function SecondaryButton(param) {
    var name = param.name, buttonText = param.buttonText, onClick = param.onClick, buttonLeftIcon = param.buttonLeftIcon, buttonRightIcon = param.buttonRightIcon, type = param.type, href = param.href, style = param.style;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
        href: href,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("button", {
            type: type,
            name: name,
            onClick: onClick,
            className: "w-full py-3 px-4  whitespace-nowrap flex items-center justify-center rounded-md font-medium bg-makdosSecondaryGray hover:bg-white transition-colors duration-300 tr text-md focus:outline-none ".concat(style && style),
            children: [
                buttonLeftIcon && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("i", {
                    className: buttonLeftIcon + " font-normal mr-1"
                }),
                buttonText,
                buttonRightIcon && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("i", {
                    className: buttonRightIcon + " font-normal ml-1"
                })
            ]
        })
    });
}
/* harmony default export */ __webpack_exports__["Z"] = (SecondaryButton);


/***/ }),

/***/ 51550:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(11527);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(50959);


function SuccessModal(param) {
    var setOpenModal = param.setOpenModal, title = param.title, message = param.message, buttonText = param.buttonText, onClick = param.onClick;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "fixed z-40 inset-0 overflow-y-auto ",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "flex items-end justify-center min-h-screen pt-4 pb-20 text-center sm:block sm:p-0 ",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "fixed inset-0 transition-opacity",
                    "aria-hidden": "true",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "absolute inset-0 bg-gray-500 opacity-75"
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                    className: "hidden sm:inline-block sm:align-middle sm:h-screen",
                    "aria-hidden": "true"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "inline-block align-bottom bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-2xl sm:w-full",
                    role: "dialog",
                    "aria-modal": "true",
                    "aria-labelledby": "modal-headline",
                    style: {
                        overflow: "initial"
                    },
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "bg-white rounded-md",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "flex justify-end items-center px-3 py-3",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("i", {
                                    onClick: function() {
                                        return setOpenModal(false);
                                    },
                                    className: "ri-close-line text-2xl text-passive cursor-pointer"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "w-full flex flex-col justify-center items-center px-5 pt-4 pb-10 ",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
                                        width: "80",
                                        height: "80",
                                        viewBox: "0 0 80 80",
                                        fill: "none",
                                        xmlns: "http://www.w3.org/2000/svg",
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                                opacity: "0.2",
                                                d: "M40 70C56.5685 70 70 56.5685 70 40C70 23.4315 56.5685 10 40 10C23.4315 10 10 23.4315 10 40C10 56.5685 23.4315 70 40 70Z",
                                                fill: "#45D85B"
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                                d: "M53.75 32.5L35.4166 50L26.25 41.25",
                                                stroke: "#45D85B",
                                                "stroke-width": "6",
                                                "stroke-linecap": "round",
                                                "stroke-linejoin": "round"
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                                d: "M40 70C56.5685 70 70 56.5685 70 40C70 23.4315 56.5685 10 40 10C23.4315 10 10 23.4315 10 40C10 56.5685 23.4315 70 40 70Z",
                                                stroke: "#45D85B",
                                                "stroke-width": "6",
                                                "stroke-linecap": "round",
                                                "stroke-linejoin": "round"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                        className: "mt-5 text-alertGreen text-2xl",
                                        children: title
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                        className: "mt-5 text-center text-cardText",
                                        children: message
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "w-full mt-10 px-20",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                                            type: "button",
                                            onClick: function() {
                                                onClick && onClick();
                                            },
                                            className: "w-full py-4 px-4 flex items-center justify-center text-textWhite rounded-md font-medium bg-alertGreen hover:bg-makdosLaci hover:text-textWhite transition-colors duration-300 tr text-md focus:outline-none",
                                            children: buttonText
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                })
            ]
        })
    });
}
/* harmony default export */ __webpack_exports__["Z"] = (SuccessModal);


/***/ }),

/***/ 24029:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


Object.defineProperty(exports, "__esModule", ({
    value: true
}));
var _extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source){
            if (Object.prototype.hasOwnProperty.call(source, key)) {
                target[key] = source[key];
            }
        }
    }
    return target;
};
var _react = __webpack_require__(50959);
var _react2 = _interopRequireDefault(_react);
var _propTypes = __webpack_require__(40507);
var _propTypes2 = _interopRequireDefault(_propTypes);
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _objectWithoutProperties(obj, keys) {
    var target = {};
    for(var i in obj){
        if (keys.indexOf(i) >= 0) continue;
        if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
        target[i] = obj[i];
    }
    return target;
}
var inputDefaultStyles = {
    width: 38,
    height: 38,
    textAlign: "center",
    borderRadius: 5,
    marginRight: 15
};
/**
 * This is react stateless component
 * Renders an input box
 * @param {Object} {
 *   focus,
 *   autoFocus,
 *   disabled,
 *   value,
 *   secure,
 *   ...rest
 * }
 * @returns
 */ var Input = function Input(_ref) {
    var focus = _ref.focus, autoFocus = _ref.autoFocus, disabled = _ref.disabled, value = _ref.value, onInputFocus = _ref.onInputFocus, index = _ref.index, secure = _ref.secure, inputStyles = _ref.inputStyles, rest = _objectWithoutProperties(_ref, [
        "focus",
        "autoFocus",
        "disabled",
        "value",
        "onInputFocus",
        "index",
        "secure",
        "inputStyles"
    ]);
    var input = (0, _react.useRef)(null);
    var componentMounted = (0, _react.useRef)(false);
    (0, _react.useEffect)(function() {
        // When component mounts
        if (autoFocus && focus) {
            input.current.focus();
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    (0, _react.useEffect)(function() {
        // When component focus updates
        if (componentMounted.current && focus) {
            input.current.focus();
        }
        componentMounted.current = true;
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        focus
    ]);
    var handelInputFocus = function handelInputFocus(event) {
        return onInputFocus(index, event);
    };
    return _react2.default.createElement("input", _extends({
        style: _extends({}, inputDefaultStyles, inputStyles),
        type: secure ? "text" : "tel",
        maxLength: "1",
        ref: input,
        disabled: disabled,
        onFocus: handelInputFocus,
        value: value || ""
    }, rest));
};
Input.propTypes = {
    focus: _propTypes2.default.bool,
    autoFocus: _propTypes2.default.bool,
    numInputs: _propTypes2.default.number,
    index: _propTypes2.default.number.isRequired,
    onChange: _propTypes2.default.func,
    disabled: _propTypes2.default.bool,
    value: _propTypes2.default.string,
    secure: _propTypes2.default.bool,
    inputStyles: _propTypes2.default.object
};
exports["default"] = _react2.default.memo(Input);


/***/ }),

/***/ 19839:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


Object.defineProperty(exports, "__esModule", ({
    value: true
}));
var _extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source){
            if (Object.prototype.hasOwnProperty.call(source, key)) {
                target[key] = source[key];
            }
        }
    }
    return target;
};
var _react = __webpack_require__(50959);
var _react2 = _interopRequireDefault(_react);
var _propTypes = __webpack_require__(40507);
var _propTypes2 = _interopRequireDefault(_propTypes);
var _Input = __webpack_require__(24029);
var _Input2 = _interopRequireDefault(_Input);
var _useOTP2 = __webpack_require__(63055);
var _useOTP3 = _interopRequireDefault(_useOTP2);
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var OtpInput = function OtpInput(_ref) {
    var OTPLength = _ref.OTPLength, disabled = _ref.disabled, autoFocus = _ref.autoFocus, _ref$value = _ref.value, value = _ref$value === undefined ? "" : _ref$value, onChange = _ref.onChange, otpType = _ref.otpType, secure = _ref.secure, className = _ref.className, inputClassName = _ref.inputClassName, inputStyles = _ref.inputStyles, style = _ref.style;
    var _useOTP = (0, _useOTP3.default)({
        autoFocus: autoFocus,
        value: value,
        otpType: otpType,
        onChange: onChange,
        OTPLength: OTPLength
    }), activeInput = _useOTP.activeInput, getOtpValue = _useOTP.getOtpValue, handleOnChange = _useOTP.handleOnChange, handleOnKeyDown = _useOTP.handleOnKeyDown, handelOnInput = _useOTP.handelOnInput, handleOnPaste = _useOTP.handleOnPaste, onInputFocus = _useOTP.onInputFocus;
    // Needs to be memorized
    var renderInputs = (0, _react.useMemo)(function() {
        var otp = getOtpValue();
        var inputs = [];
        // eslint-disable-next-line no-plusplus
        for(var index = 0; index < OTPLength; index++){
            inputs.push(_react2.default.createElement(_Input2.default, {
                className: inputClassName,
                inputStyles: inputStyles,
                key: index,
                focus: activeInput === index,
                value: otp[index],
                onChange: handleOnChange,
                onKeyDown: handleOnKeyDown,
                onInput: handelOnInput,
                onPaste: handleOnPaste,
                onInputFocus: onInputFocus,
                index: index,
                // onBlur={() => setActiveInput(-1)}
                disabled: disabled,
                autoFocus: autoFocus,
                secure: secure,
                "data-testid": "input",
                placeholder: "•"
            }));
        }
        return inputs;
    }, [
        getOtpValue,
        OTPLength,
        inputClassName,
        inputStyles,
        activeInput,
        handleOnChange,
        handleOnKeyDown,
        handelOnInput,
        handleOnPaste,
        onInputFocus,
        disabled,
        autoFocus,
        secure
    ]);
    return _react2.default.createElement("div", {
        style: _extends({
            display: "flex"
        }, style),
        className: "" + className,
        "data-testid": "otp-input-root"
    }, renderInputs);
};
OtpInput.propTypes = {
    className: _propTypes2.default.string,
    inputClassName: _propTypes2.default.string,
    OTPLength: _propTypes2.default.number,
    onChange: _propTypes2.default.func.isRequired,
    disabled: _propTypes2.default.bool,
    autoFocus: _propTypes2.default.bool,
    secure: _propTypes2.default.bool,
    otpType: _propTypes2.default.oneOf([
        "number",
        "alpha",
        "alphanumeric",
        "any"
    ]),
    value: _propTypes2.default.oneOfType([
        _propTypes2.default.string,
        _propTypes2.default.number
    ]),
    inputStyles: _propTypes2.default.object,
    style: _propTypes2.default.object
};
OtpInput.defaultProps = {
    className: "",
    inputClassName: "",
    OTPLength: 4,
    onChange: function onChange() {},
    disabled: false,
    secure: false,
    autoFocus: false,
    value: "",
    otpType: "any",
    inputStyles: {},
    style: {}
};
exports["default"] = OtpInput;


/***/ }),

/***/ 52710:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


Object.defineProperty(exports, "__esModule", ({
    value: true
}));
var _extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source){
            if (Object.prototype.hasOwnProperty.call(source, key)) {
                target[key] = source[key];
            }
        }
    }
    return target;
};
var _react = __webpack_require__(50959);
var _react2 = _interopRequireDefault(_react);
var _propTypes = __webpack_require__(40507);
var _propTypes2 = _interopRequireDefault(_propTypes);
var _resendOTP = __webpack_require__(80707);
var _resendOTP2 = _interopRequireDefault(_resendOTP);
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _objectWithoutProperties(obj, keys) {
    var target = {};
    for(var i in obj){
        if (keys.indexOf(i) >= 0) continue;
        if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
        target[i] = obj[i];
    }
    return target;
}
function ResendOTP(_ref) {
    var renderTime = _ref.renderTime, renderText = _ref.renderText, renderButton = _ref.renderButton, codeAgain = _ref.codeAgain, codeError = _ref.codeError, codeSec = _ref.codeSec, style = _ref.style, className = _ref.className, props = _objectWithoutProperties(_ref, [
        "renderTime",
        "renderTimeIcon",
        "renderText",
        "renderButton",
        "style",
        "className"
    ]);
    var _useResendOTP = (0, _resendOTP2.default)(props), remainingTime = _useResendOTP.remainingTime, handelResendClick = _useResendOTP.handelResendClick;
    return _react2.default.createElement("div", {
        className: className || "",
        "data-testid": "otp-resend-root",
        class: codeSec === "seconds" ? "root-otp" : "otp-root",
        style: _extends({
            textAlign: "center",
            justifyContent: "space-between",
            fontSize: 14,
            marginTop: 5
        }, style)
    }, renderText ? renderText() : _react2.default.createElement("span", {
        className: "resend-text"
    }, codeError), renderButton ? renderButton({
        disabled: remainingTime !== 0,
        onClick: handelResendClick,
        remainingTime: remainingTime
    }) : _react2.default.createElement("button", {
        disabled: remainingTime !== 0,
        onClick: handelResendClick
    }, codeAgain), _react2.default.createElement("div", {
        style: _extends({
            width: "82px",
            margin: "0 auto",
            textAlign: "center",
            color: "#999999"
        }, style)
    }, _react2.default.createElement("div", {
        className: "ri-timer-line float-left"
    }), renderTime ? renderTime(remainingTime) : _react2.default.createElement("div", {
        className: "text-xs ml-1 resend-text-position float-left"
    }, remainingTime, " " + codeSec)));
}
ResendOTP.defaultProps = {
    maxTime: 60,
    timeInterval: 1000,
    style: {
        fontSize: 14,
        color: "#555555"
    }
};
ResendOTP.propTypes = {
    onTimerComplete: _propTypes2.default.func,
    onResendClick: _propTypes2.default.func,
    renderTime: _propTypes2.default.func,
    renderText: _propTypes2.default.func,
    renderButton: _propTypes2.default.func,
    maxTime: _propTypes2.default.number,
    timeInterval: _propTypes2.default.number,
    style: _propTypes2.default.object,
    className: _propTypes2.default.string
};
exports["default"] = ResendOTP;


/***/ }),

/***/ 80707:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


Object.defineProperty(exports, "__esModule", ({
    value: true
}));
var _slicedToArray = function() {
    var sliceIterator = function sliceIterator(arr, i) {
        var _arr = [];
        var _n = true;
        var _d = false;
        var _e = undefined;
        try {
            for(var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true){
                _arr.push(_s.value);
                if (i && _arr.length === i) break;
            }
        } catch (err) {
            _d = true;
            _e = err;
        } finally{
            try {
                if (!_n && _i["return"]) _i["return"]();
            } finally{
                if (_d) throw _e;
            }
        }
        return _arr;
    };
    return function(arr, i) {
        if (Array.isArray(arr)) {
            return arr;
        } else if (Symbol.iterator in Object(arr)) {
            return sliceIterator(arr, i);
        } else {
            throw new TypeError("Invalid attempt to destructure non-iterable instance");
        }
    };
}();
var _react = __webpack_require__(50959);
var useResendOTP = function useResendOTP(_ref) {
    var maxTime = _ref.maxTime, onTimerComplete = _ref.onTimerComplete, timeInterval = _ref.timeInterval, onResendClick = _ref.onResendClick;
    var timeout = (0, _react.useRef)();
    var _useState = (0, _react.useState)(maxTime), _useState2 = _slicedToArray(_useState, 2), remainingTime = _useState2[0], setRemainingTime = _useState2[1];
    (0, _react.useEffect)(function() {
        if (timeout.current && remainingTime === 0) {
            clearTimeout(timeout.current);
            if (onTimerComplete) {
                onTimerComplete();
            }
        } else {
            timeout.current = setTimeout(function() {
                setRemainingTime(function(t) {
                    return t - 1;
                });
            }, timeInterval);
        }
        return function() {
            clearTimeout(timeout);
        };
    }, [
        onTimerComplete,
        remainingTime,
        timeInterval
    ]);
    var handelResendClick = function handelResendClick() {
        if (onResendClick) {
            onResendClick(remainingTime === 0);
        }
        setRemainingTime(maxTime);
    //TODO: Resend new code by sending request to the appropriate API
    };
    return {
        handelResendClick: handelResendClick,
        remainingTime: remainingTime
    };
};
exports["default"] = useResendOTP;


/***/ }),

/***/ 63055:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


Object.defineProperty(exports, "__esModule", ({
    value: true
}));
var _slicedToArray = function() {
    var sliceIterator = function sliceIterator(arr, i) {
        var _arr = [];
        var _n = true;
        var _d = false;
        var _e = undefined;
        try {
            for(var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true){
                _arr.push(_s.value);
                if (i && _arr.length === i) break;
            }
        } catch (err) {
            _d = true;
            _e = err;
        } finally{
            try {
                if (!_n && _i["return"]) _i["return"]();
            } finally{
                if (_d) throw _e;
            }
        }
        return _arr;
    };
    return function(arr, i) {
        if (Array.isArray(arr)) {
            return arr;
        } else if (Symbol.iterator in Object(arr)) {
            return sliceIterator(arr, i);
        } else {
            throw new TypeError("Invalid attempt to destructure non-iterable instance");
        }
    };
}();
var _react = __webpack_require__(50959);
// const LOWER_A_KEYCODE = 97;
var UPPER_A_KEYCODE = 65;
var LOWER_Z_KEYCODE = 122;
// const UPPER_Z_KEYCODE = 90;
var ZERO_KEYCODE = 48;
var NINE_KEYCODE = 57;
var useOTP = function useOTP(_ref) {
    var autoFocus = _ref.autoFocus, value = _ref.value, otpType = _ref.otpType, onChange = _ref.onChange, OTPLength = _ref.OTPLength;
    var _useState = (0, _react.useState)(autoFocus ? 0 : -1), _useState2 = _slicedToArray(_useState, 2), activeInput = _useState2[0], setActiveInput = _useState2[1];
    var getOtpValue = function getOtpValue() {
        return value ? value.toString().split("") : [];
    };
    // Helper to return OTP from input
    var handleOtpChange = function handleOtpChange(otp) {
        var otpValue = otp.join("");
        // if (otpType === "number") {
        //   otpValue = +otpValue;
        // }
        onChange(otpValue);
    };
    // Focus on input by index
    var focusInput = function focusInput(input) {
        var nextActiveInput = Math.max(Math.min(OTPLength - 1, input), 0);
        setActiveInput(nextActiveInput);
    };
    /**
   * @typedef {"next" | "prev"} FocusDirections
   * @param {FocusDirections} direction
   */ var focusInputByDirection = function focusInputByDirection() {
        var direction = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "next";
        focusInput(direction === "next" ? activeInput + 1 : activeInput - 1);
    };
    // Change OTP value at focused input
    var changeActiveInputValue = function changeActiveInputValue(_ref2) {
        var _ref3 = _slicedToArray(_ref2, 1), nextValue = _ref3[0];
        var otp = getOtpValue();
        otp[activeInput] = nextValue;
        handleOtpChange(otp);
    };
    // Handle pasted OTP
    var handleOnPaste = function handleOnPaste(e, data) {
        e.preventDefault();
        var otp = getOtpValue();
        // Get pastedData in an array of max size (num of inputs - current position)
        var clipboardData =  false ? 0 : e.clipboardData.getData("text/plain").slice(0, OTPLength - activeInput).split("");
        // Paste data from focused input onwards
        // eslint-disable-next-line no-plusplus
        for(var pos = 0; pos < OTPLength; ++pos){
            if (pos >= activeInput && clipboardData.length > 0) {
                otp[pos] = clipboardData.shift();
            }
        }
        // Pass copied value through onChange rules
        var filteredOtpValue = [
            otp.length
        ];
        var validCharIndex = 0;
        for(var charIndex = 0; charIndex < otp.length; ++charIndex){
            if (isValidateChar(otp[charIndex])) {
                filteredOtpValue[validCharIndex] = otp[charIndex];
                validCharIndex++;
            }
        }
        handleOtpChange(filteredOtpValue);
    };
    var isValidateChar = function isValidateChar(char) {
        switch(otpType){
            case "number":
                return !(char.charCodeAt(0) > NINE_KEYCODE || char.charCodeAt(0) < ZERO_KEYCODE);
            case "alpha":
                return !(char.charCodeAt(0) > LOWER_Z_KEYCODE || char.charCodeAt(0) < UPPER_A_KEYCODE);
            case "alphanumeric":
                return !(char.charCodeAt(0) > LOWER_Z_KEYCODE || char.charCodeAt(0) < ZERO_KEYCODE);
            default:
                return true;
        }
    };
    var handleOnChange = function handleOnChange(e) {
        if (isValidateChar(e.target.value)) {
            changeActiveInputValue(e.target.value);
            focusInputByDirection("next");
        }
    };
    // Handle cases of backspace, delete, left arrow, right arrow
    var handleOnKeyDown = function handleOnKeyDown(e) {
        switch(e.key){
            case "Backspace":
                e.preventDefault();
                changeActiveInputValue("");
                focusInputByDirection("prev");
                break;
            case "Delete":
                e.preventDefault();
                changeActiveInputValue("");
                break;
            case "ArrowLeft":
                e.preventDefault();
                focusInputByDirection("prev");
                break;
            case "ArrowRight":
                e.preventDefault();
                focusInputByDirection("next");
                break;
            default:
                break;
        }
    };
    var handelOnInput = function handelOnInput(e) {
        if (e.target.value.length > 1) {
            e.preventDefault();
            focusInputByDirection("next");
        }
    };
    var onInputFocus = function onInputFocus(index, event) {
        setActiveInput(index);
        event.target.select();
    };
    return {
        activeInput: activeInput,
        getOtpValue: getOtpValue,
        handleOnChange: handleOnChange,
        handleOnKeyDown: handleOnKeyDown,
        handelOnInput: handelOnInput,
        handleOnPaste: handleOnPaste,
        onInputFocus: onInputFocus
    };
};
exports["default"] = useOTP;


/***/ }),

/***/ 35332:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

var __webpack_unused_export__;

__webpack_unused_export__ = ({
    value: true
});
var _ResendOTP = __webpack_require__(52710);
__webpack_unused_export__ = ({
    enumerable: true,
    get: function get() {
        return _interopRequireDefault(_ResendOTP).default;
    }
});
var _OTPReader = __webpack_require__(19839);
Object.defineProperty(exports, "ZP", ({
    enumerable: true,
    get: function get() {
        return _interopRequireDefault(_OTPReader).default;
    }
}));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}


/***/ }),

/***/ 4967:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ layout_Layout; }
});

// EXTERNAL MODULE: ./node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(59072);
// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(11527);
// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(50959);
// EXTERNAL MODULE: ./store/ConfigurationStore.js
var ConfigurationStore = __webpack_require__(20363);
// EXTERNAL MODULE: ./store/AuthStore.js
var AuthStore = __webpack_require__(57305);
// EXTERNAL MODULE: ./store/GlobalStore.js
var GlobalStore = __webpack_require__(36345);
// EXTERNAL MODULE: ./services/allServices.js + 1 modules
var allServices = __webpack_require__(63700);
// EXTERNAL MODULE: ./node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(57135);
// EXTERNAL MODULE: ./node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(72006);
// EXTERNAL MODULE: ./node_modules/.pnpm/tslib@2.4.1/node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(80677);
// EXTERNAL MODULE: ./components/FormElements/SimpleTextBox.js
var SimpleTextBox = __webpack_require__(53909);
// EXTERNAL MODULE: ./components/FormElements/IconTextBox.js
var IconTextBox = __webpack_require__(43055);
// EXTERNAL MODULE: ./components/FormElements/Button.js
var Button = __webpack_require__(62303);
// EXTERNAL MODULE: ./components/FormElements/SecondaryButton.js
var SecondaryButton = __webpack_require__(88643);
// EXTERNAL MODULE: ./node_modules/.pnpm/next@12.3.4_react-dom@18.2.0_react@18.2.0/node_modules/next/link.js
var next_link = __webpack_require__(13786);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-hook-form@6.15.8_react@18.2.0/node_modules/react-hook-form/dist/index.esm.js
var index_esm = __webpack_require__(78730);
// EXTERNAL MODULE: ./node_modules/.pnpm/yup@0.32.11/node_modules/yup/es/index.js + 25 modules
var es = __webpack_require__(55423);
// EXTERNAL MODULE: ./node_modules/.pnpm/@hookform+resolvers@1.3.0_react-hook-form@6.15.8/node_modules/@hookform/resolvers/dist/yup.js
var yup = __webpack_require__(79760);
// EXTERNAL MODULE: ./components/ContentAlerts/AlertDanger.js
var AlertDanger = __webpack_require__(35080);
// EXTERNAL MODULE: ./hooks/index.js
var hooks = __webpack_require__(2218);
// EXTERNAL MODULE: ./node_modules/.pnpm/next-i18next@13.0.2_i18next@22.4.6_next@12.3.4_react-i18next@12.1.1_react@18.2.0/node_modules/next-i18next/dist/esm/index.js + 11 modules
var esm = __webpack_require__(66264);
// EXTERNAL MODULE: ./components/FormElements/PhoneSelectBox.js
var PhoneSelectBox = __webpack_require__(75967);
// EXTERNAL MODULE: ./node_modules/.pnpm/moment@2.29.4/node_modules/moment/moment.js
var moment = __webpack_require__(98777);
var moment_default = /*#__PURE__*/__webpack_require__.n(moment);
// EXTERNAL MODULE: ./components/Validation/index.js
var Validation = __webpack_require__(35332);
// EXTERNAL MODULE: ./node_modules/.pnpm/crypto-js@4.1.1/node_modules/crypto-js/index.js
var crypto_js = __webpack_require__(30507);
var crypto_js_default = /*#__PURE__*/__webpack_require__.n(crypto_js);
// EXTERNAL MODULE: ./node_modules/.pnpm/next@12.3.4_react-dom@18.2.0_react@18.2.0/node_modules/next/router.js
var next_router = __webpack_require__(63498);
// EXTERNAL MODULE: ./components/Toast/AllToast.js
var AllToast = __webpack_require__(86749);
;// CONCATENATED MODULE: ./components/SignIn/SignIn.js



























var schema = es/* object */.Ry().shape({
    email: es/* string */.Z_().required(),
    password: es/* string */.Z_().required()
});
function SignIn(param) {
    var setOpenNewPasswordModal = param.setOpenNewPasswordModal;
    var useOutsideAlerter = //when outside of the combobox clicked, it will be closed
    function useOutsideAlerter(ref) {
        (0,react.useEffect)(function() {
            function handleClickOutside(event) {
                if (ref.current && !ref.current.contains(event.target)) {
                    setLogginOpen(false);
                }
            }
            document.addEventListener("mousedown", handleClickOutside);
            return function() {
                document.removeEventListener("mousedown", handleClickOutside);
            };
        }, [
            ref
        ]);
    };
    var ref;
    var t = (0,esm/* useTranslation */.$G)([
        "common",
        "nav"
    ]).t;
    var router = (0,next_router.useRouter)();
    var ref1 = (0,_sliced_to_array/* default */.Z)((0,AuthStore/* useAuthStore */.t)(function(state) {
        return [
            state.isLoggin,
            state.setIsLoggin,
            state.setLogginOpen,
            state.setUserInformations,
            state.beforeLogginStatus,
            state.setBeforeLogginStatus,
            state.beforeLogginInfo,
            state.setBeforeLogginInfo
        ];
    }), 8), isLoggin = ref1[0], setIsLoggin = ref1[1], setLogginOpen = ref1[2], setUserInformations = ref1[3], beforeLogginStatus = ref1[4], setBeforeLogginStatus = ref1[5], beforeLogginInfo = ref1[6], setBeforeLogginInfo = ref1[7];
    var windowSize = (0,hooks/* useWindowSize */.iP)();
    var ref2 = (0,_sliced_to_array/* default */.Z)((0,GlobalStore/* useGlobalStore */.s)(function(state) {
        return [
            state.setPermissions
        ];
    }), 1), setPermissions = ref2[0];
    var ref3 = (0,_sliced_to_array/* default */.Z)((0,ConfigurationStore/* useConfigurationStore */.w)(function(state) {
        return [
            state.setBasketCount
        ];
    }), 1), setBasketCount = ref3[0];
    var ref4 = (0,react.useState)(false), displayDanger = ref4[0], setDisplayDanger = ref4[1];
    var ref5 = (0,index_esm/* useForm */.cI)({
        resolver: (0,yup/* yupResolver */.S)(schema)
    }), register = ref5.register, handleSubmit = ref5.handleSubmit, errors = ref5.errors;
    var ref6 = (0,react.useState)(false), passwordReset = ref6[0], setPasswordReset = ref6[1];
    var ref7 = (0,react.useState)("1"), selectedTab = ref7[0], setSelectedTab = ref7[1];
    var ref8 = (0,react.useState)(""), email = ref8[0], setEmail = ref8[1];
    var ref9 = (0,react.useState)(""), password = ref9[0], setPassword = ref9[1];
    var ref10 = (0,react.useState)(""), phone = ref10[0], setPhone = ref10[1];
    var ref11 = (0,_sliced_to_array/* default */.Z)((0,hooks/* useConfigureSelectBoxItem */.HU)(), 2), phoneList = ref11[0], setPhoneList = ref11[1];
    var ref12 = (0,react.useState)(), selectedPhone = ref12[0], setSelectedPhone = ref12[1];
    var ref13 = (0,react.useState)("1"), isSendMail = ref13[0], setIsSendMail = ref13[1];
    var ref14 = (0,react.useState)(false), openTfaView = ref14[0], setOpenTfaView = ref14[1];
    var ref15 = (0,react.useState)(5), loginBanCount = ref15[0], setLoginBanCount = ref15[1];
    var ref16 = (0,react.useState)(""), otp = ref16[0], setOtp = ref16[1];
    var encryptMessage = function(message) {
        var secretKey = "R2dxkf22";
        var cipherText = crypto_js_default().AES.encrypt(JSON.stringify(message), secretKey);
        return cipherText.toString();
    };
    var onBeforeLogin = function(data) {
        var config = {
            grant_type: "password",
            scope: "",
            client_id: "",
            client_secret: "",
            username: data.email,
            password: data.password
        };
        var beforeConfig = {
            email: data.email,
            password: data.password
        };
        (0,allServices/* beforeLogin */.vW)(beforeConfig).then(function(res) {
            if ((res === null || res === void 0 ? void 0 : res.status) !== "password_is_wrong" && (res === null || res === void 0 ? void 0 : res.status) !== "incorrect_username_or_password" && (res === null || res === void 0 ? void 0 : res.status) !== "check_login_info") {
                if ((res === null || res === void 0 ? void 0 : res.status) === "code_sent") {
                    setOpenTfaView(res);
                    setLoginBanCount(5);
                    setDisplayDanger(false);
                }
                if ((res === null || res === void 0 ? void 0 : res.status) === false) {
                    setDisplayDanger(res.message);
                }
                if ((res === null || res === void 0 ? void 0 : res.status) === "code_not_sent") {
                    setDisplayDanger("Kod g\xf6nderilemedi.");
                }
                if ((res === null || res === void 0 ? void 0 : res.status) === "tfa_disabled") {
                    var ref;
                    if ((res === null || res === void 0 ? void 0 : (ref = res.authorized_accounts) === null || ref === void 0 ? void 0 : ref.length) === 0) {
                        onLoginDirect(config, res === null || res === void 0 ? void 0 : res.own_account);
                    } else {
                        setBeforeLogginStatus(res);
                        setBeforeLogginInfo(config);
                    }
                }
            } else {
                setDisplayDanger("Eposta veya parola hatalı.");
            }
        }).catch(function(err) {
            setDisplayDanger("Eposta veya parola hatalı.");
        });
    };
    var onBeforeLoginCheck = function() {
        var config = {
            grant_type: "password",
            scope: "",
            client_id: "",
            client_secret: "",
            username: email,
            password: password
        };
        var checkData = {
            email: email,
            code: otp
        };
        (0,allServices/* beforeLoginCheck */.l2)(checkData).then(function(res) {
            if (res.status === "code_match") {
                var ref;
                if ((res === null || res === void 0 ? void 0 : (ref = res.authorized_accounts) === null || ref === void 0 ? void 0 : ref.length) === 0) {
                    onLoginDirect(config, res === null || res === void 0 ? void 0 : res.own_account);
                } else {
                    setBeforeLogginStatus(res);
                    setBeforeLogginInfo(config);
                    setOpenTfaView(null);
                }
            } else {
                setDisplayDanger("Hatalı aktivasyon kodu.");
                if (res.status === "you_are_banned" || res.status === "account_blocked") {
                    setLoginBanCount(res);
                } else {
                    setLoginBanCount(5 - res.error_count);
                }
            }
        });
    };
    var onLogin = function(onSubmit) {
        var loginInfo = (0,_object_spread/* default */.Z)({}, beforeLogginInfo);
        loginInfo.client_secret = onSubmit.id;
        (0,allServices/* login */.x4)(loginInfo).then(function(data) {
            if (data.access_token) {
                var ref;
                setIsLoggin(true);
                setUserInformations({
                    access_token: data === null || data === void 0 ? void 0 : data.access_token,
                    customer_info: data === null || data === void 0 ? void 0 : data.customer_info
                });
                setBeforeLogginInfo({});
                setBeforeLogginStatus(false);
                localStorage.setItem("u_id", data === null || data === void 0 ? void 0 : (ref = data.customer_info) === null || ref === void 0 ? void 0 : ref.customer_code);
                localStorage.setItem("__u_is_resp", data === null || data === void 0 ? void 0 : data.is_responsible);
                if (data.permissions && (data === null || data === void 0 ? void 0 : data.is_responsible)) {
                    localStorage.setItem("__u_per", encryptMessage(data === null || data === void 0 ? void 0 : data.permissions));
                    setPermissions(data === null || data === void 0 ? void 0 : data.permissions);
                }
                (0,allServices/* getBasketCount */.cH)().then(function(data) {
                    setBasketCount(data.count);
                }).catch(function(err) {
                    setBasketCount(0);
                });
                setLogginOpen(false);
            }
        }).catch(function(err) {
            setDisplayDanger(true);
        });
    };
    var onLoginDirect = function(config, ownData) {
        config.client_secret = ownData.id;
        (0,allServices/* login */.x4)(config).then(function(data) {
            if (data.access_token) {
                var ref;
                setIsLoggin(true);
                setUserInformations({
                    access_token: data === null || data === void 0 ? void 0 : data.access_token,
                    customer_info: data === null || data === void 0 ? void 0 : data.customer_info
                });
                localStorage.setItem("u_id", data === null || data === void 0 ? void 0 : (ref = data.customer_info) === null || ref === void 0 ? void 0 : ref.customer_code);
                localStorage.setItem("__u_is_resp", data === null || data === void 0 ? void 0 : data.is_responsible);
                if (data.permissions && (data === null || data === void 0 ? void 0 : data.is_responsible)) {
                    localStorage.setItem("__u_per", encryptMessage(data === null || data === void 0 ? void 0 : data.permissions));
                    setPermissions(data === null || data === void 0 ? void 0 : data.permissions);
                }
                (0,allServices/* getBasketCount */.cH)().then(function(data) {
                    setBasketCount(data.count);
                }).catch(function(err) {
                    setBasketCount(0);
                });
                setLogginOpen(false);
            }
        }).catch(function(err) {
            setDisplayDanger(true);
        });
    };
    var onGetCountry = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            var countries;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        countries = [];
                        return [
                            4,
                            (0,allServices/* getCountry */.rZ)()
                        ];
                    case 1:
                        countries = _state.sent();
                        setPhoneList(countries, "phone_code", "country_name");
                        return [
                            2
                        ];
                }
            });
        });
        return function onGetCountry() {
            return _ref.apply(this, arguments);
        };
    }();
    var wrapperRef = (0,react.useRef)(null);
    useOutsideAlerter(wrapperRef);
    var onSendPasswordCode = function() {
        if (email !== "" && phone !== "") {
            (0,allServices/* forgotPasswordSendCode */.PZ)(email, selectedPhone.id, phone, isSendMail == "1" ? "mail" : "sms").then(function(res) {
                if (res.status === "code_sent") {
                    setOpenNewPasswordModal(email);
                } else if (res.status === "check_info") {
                    (0,AllToast/* alertToast */.qC)("Hata", "Bilgilerinizi kontrol ediniz.");
                } else {
                    (0,AllToast/* alertToast */.qC)("Hata", "Bir sorun oluştu");
                }
            }).catch(function(err) {
                (0,AllToast/* alertToast */.qC)("Hata", "Bir sorun oluştu");
            });
        } else {
            setDisplayDanger(true);
        }
    };
    (0,react.useEffect)(function() {
        phoneList.map(function(item) {
            if (item.id === "90") {
                setSelectedPhone(item);
            }
        });
    }, [
        phoneList
    ]);
    (0,react.useEffect)(function() {
        onGetCountry();
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        ref: windowSize.width > 800 ? wrapperRef : null,
        className: "relative flex flex-col justify-center px-4 py-6 bg-white rounded-md w-96 lg:px-6 lg:shadow-md lg:border-t-4 lg:border-makdosYellow",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                className: "absolute hidden right-16 -top-3 lg:block ",
                width: "9",
                height: "8",
                viewBox: "0 0 9 8",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M3.6273 0.5C4.01517 -0.166667 4.98483 -0.166667 5.3727 0.5L8.86349 6.5C9.25136 7.16667 8.76652 8 7.99079 8H1.00921C0.233477 8 -0.251356 7.16667 0.13651 6.5L3.6273 0.5Z",
                    fill: "#FFDF0F"
                })
            }),
            !beforeLogginStatus && !passwordReset && !openTfaView && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "mx-auto ",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                        className: "text-2xl font-medium text-selectboxText",
                        children: t("common:signIn")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "mt-3 text-cardText",
                        children: t("common:signInDescription")
                    }),
                    displayDanger && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "mt-2",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AlertDanger/* default */.Z, {
                            message: displayDanger
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
                        onSubmit: handleSubmit(onBeforeLogin),
                        className: "mt-5",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "mb-4",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SimpleTextBox/* default */.Z, {
                                        innerRef: register,
                                        errors: errors,
                                        labelName: t("common:e-mail"),
                                        inputName: "email",
                                        placeholder: t("common:emailPlaceholder"),
                                        value: email,
                                        onChange: function(e) {
                                            return setEmail(e === null || e === void 0 ? void 0 : e.toLowerCase());
                                        }
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "text-sm text-discountRed",
                                        children: errors.email && t("common:emailError")
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(IconTextBox/* default */.Z, {
                                innerRef: register,
                                errors: errors,
                                labelName: t("common:password"),
                                inputName: "password",
                                type: "password",
                                placeholder: "******",
                                iconChange: true,
                                textBoxIcon: "ri-eye-line",
                                textBoxSecondIcon: "ri-eye-off-line",
                                value: password,
                                onChange: function(e) {
                                    return setPassword(e);
                                }
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "text-sm text-discountRed",
                                children: errors.password && t("common:passwordError")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                onClick: function() {
                                    return setPasswordReset(true);
                                },
                                className: "mt-3 cursor-pointer text-textGray",
                                children: t("common:forgotPassword")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "mt-5 lg:flex lg:flex-row-reverse",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                        name: "signIn",
                                        buttonText: t("common:signIn"),
                                        buttonLeftIcon: "ri-login-box-line",
                                        type: "submit"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "mt-3 lg:mr-3 lg:mt-0",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                            href: router.pathname == "/configuration" ? "/signup?redirect=".concat(t("nav:configuration")) : "/signup",
                                            as: router.pathname == "/configuration" ? t("nav:signupquery") + t("nav:configuration") : t("nav:signup"),
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SecondaryButton/* default */.Z, {
                                                name: "signUp",
                                                buttonText: t("common:signUp"),
                                                buttonLeftIcon: "ri-user-line",
                                                type: "button",
                                                onClick: function() {
                                                    return setLogginOpen(false);
                                                }
                                            })
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            beforeLogginStatus && !passwordReset && !openTfaView && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "w-full mx-auto ",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        onClick: function() {
                            return onLogin(beforeLogginStatus === null || beforeLogginStatus === void 0 ? void 0 : beforeLogginStatus.own_account);
                        },
                        className: "w-full px-4 py-3 rounded-md cursor-pointer bg-makdosYellow",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex items-end",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                        className: "text-lg ri-login-box-line text-titleColor"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "ml-2 font-medium text-titleColor",
                                        children: t("common:normalSignIn")
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "mt-1 text-sm text-cardText",
                                children: t("common:ownPanelSignIn")
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "h-0.5 w-full bg-gray-200 my-4"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "mb-2 text-xl font-semibold text-selectboxText",
                        children: t("common:authorizedAccounts")
                    }),
                    beforeLogginStatus === null || beforeLogginStatus === void 0 ? void 0 : (ref = beforeLogginStatus.authorized_accounts) === null || ref === void 0 ? void 0 : ref.map(function(item, index) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "w-full p-2 transition-all duration-200 rounded-md cursor-pointer text-titleColor hover:bg-makdosSecondaryGray",
                            onClick: function() {
                                onLogin(item);
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                children: item === null || item === void 0 ? void 0 : item.customer_name
                            })
                        }, index);
                    })
                ]
            }),
            !beforeLogginStatus && passwordReset && !openTfaView && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "w-full mx-auto",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                        className: "text-2xl font-medium text-selectboxText",
                        children: t("common:resetPassword")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "mt-3 text-cardText",
                        children: t("common:resetPasswordDescription")
                    }),
                    displayDanger && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "mt-2",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AlertDanger/* default */.Z, {
                            message: t("common:emptyFieldAlert")
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "mt-5",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SimpleTextBox/* default */.Z, {
                            value: email,
                            onChange: function(v) {
                                return setEmail(v === null || v === void 0 ? void 0 : v.toLowerCase());
                            },
                            labelName: t("common:e-mail"),
                            inputName: "e-posta",
                            placeholder: t("common:emailPlaceholder")
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex space-x-2",
                        children: [
                            selectedPhone && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "mt-5 md:mt-0",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PhoneSelectBox/* default */.Z, {
                                    data: phoneList,
                                    selectedItem: selectedPhone,
                                    setSelectedItem: function(v) {
                                        return setSelectedPhone(v);
                                    },
                                    labelName: t("common:code")
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(SimpleTextBox/* default */.Z, {
                                value: phone,
                                onChange: function(v) {
                                    return setPhone(v === null || v === void 0 ? void 0 : v.replaceAll(/\D/g, ""));
                                },
                                labelName: t("common:phoneNumber"),
                                inputName: "phone",
                                placeholder: "5555555"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "mt-3 text-cardText",
                        children: t("common:verificationMethod")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex mt-6 mb-6",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                        type: "radio",
                                        id: "newpass1",
                                        name: "newPass",
                                        onChange: function() {
                                            return setIsSendMail("1");
                                        },
                                        checked: isSendMail == "1"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                        htmlFor: "newpass1",
                                        children: t("common:e-mail")
                                    })
                                ]
                            }),
                            (selectedPhone === null || selectedPhone === void 0 ? void 0 : selectedPhone.id) === "90" && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "ml-10",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                        type: "radio",
                                        id: "newpass2",
                                        name: "newPass",
                                        onChange: function() {
                                            return setIsSendMail("2");
                                        },
                                        checked: isSendMail == "2"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                        htmlFor: "newpass2",
                                        children: "Sms"
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                        style: "mt-4",
                        onClick: function() {
                            return onSendPasswordCode();
                        },
                        name: "personelButton",
                        buttonText: t("common:send"),
                        buttonLeftIcon: "ri-checkbox-circle-line"
                    })
                ]
            }),
            openTfaView && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "w-full mx-auto",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "text-2xl font-medium text-selectboxText",
                        children: openTfaView.code_type === "tfa_mail" ? t("common:emailActivation") : t("common:smsActivation")
                    }),
                    displayDanger && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "mt-2",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AlertDanger/* default */.Z, {
                            message: displayDanger
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "mt-3 text-cardText",
                        children: openTfaView.code_type === "tfa_mail" ? t("common:emailCodeEnter") : t("common:smsActivation")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "flex items-center justify-center w-full my-5 ml-2",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Validation/* default */.ZP, {
                            value: otp,
                            onChange: function(v) {
                                return setOtp(v.toLocaleUpperCase("tr"));
                            },
                            autoFocus: true,
                            inputClassName: "text-gray-500 border border-textGray  focus:border-1 focus:border-makdosYellow focus:ring-1 focus:ring-makdosYellow focus:outline-none",
                            OTPLength: 6,
                            otpType: "string",
                            disabled: false,
                            secure: true
                        })
                    }),
                    loginBanCount && loginBanCount < 5 && (loginBanCount === null || loginBanCount === void 0 ? void 0 : loginBanCount.status) !== "you_are_banned" && (loginBanCount === null || loginBanCount === void 0 ? void 0 : loginBanCount.status) !== "account_blocked" ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "mt-3",
                        children: [
                            t("common:remainingEntry"),
                            " : ",
                            loginBanCount
                        ]
                    }) : loginBanCount.status === "you_are_banned" || loginBanCount.status === "account_blocked" ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "mt-3",
                        children: [
                            moment_default()(loginBanCount === null || loginBanCount === void 0 ? void 0 : loginBanCount.ban_end_time).format("DD-MM-YYYY HH:mm"),
                            " ",
                            t("common:bannedUntil"),
                            "."
                        ]
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                        style: "mt-4",
                        onClick: function() {
                            return onBeforeLoginCheck();
                        },
                        name: "checkLoginButton",
                        buttonText: t("common:send"),
                        buttonLeftIcon: "ri-checkbox-circle-line"
                    })
                ]
            })
        ]
    });
}
/* harmony default export */ var SignIn_SignIn = (SignIn);

;// CONCATENATED MODULE: ./components/Header/HeaderCard.js


var HeaderCard = /*#__PURE__*/ react.forwardRef(function(param, ref) {
    var icon = param.icon, title = param.title, description = param.description, href = param.href, as = param.as, onClick = param.onClick, disable = param.disable;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        ref: ref,
        onClick: onClick,
        className: " col-span-1 rounded-md border-2 mt-2 lg:mt-0 py-5 px-4 border-makdosSecondaryGray ".concat(disable ? "opacity-40 cursor-not-allowed" : "hover:bg-makdosYellow", "   transition-all  duration-300 hover:shadow-yellowShadow hover:border-transparent cursor-pointer"),
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "flex",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "px-1 mr-2",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                        className: icon + " text-3xl"
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "w-full",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                            className: "text-lg font-semibold text-selectboxText",
                            children: title
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: "text-sm text-cardText",
                            children: description
                        })
                    ]
                })
            ]
        })
    });
});
/* harmony default export */ var Header_HeaderCard = (HeaderCard);

// EXTERNAL MODULE: ./helpers/helpersFunc.js + 2 modules
var helpersFunc = __webpack_require__(65126);
;// CONCATENATED MODULE: ./components/MyAccount/index.js










function MyAccount() {
    var useOutsideAlerter = //when outside of the combobox clicked, it will be closed
    function useOutsideAlerter(ref) {
        (0,react.useEffect)(function() {
            function handleClickOutside(event) {
                if (ref.current && !ref.current.contains(event.target)) {
                    setMyAccountOpen(false);
                }
            }
            document.addEventListener("mousedown", handleClickOutside);
            return function() {
                document.removeEventListener("mousedown", handleClickOutside);
            };
        }, [
            ref
        ]);
    };
    var ref, ref1;
    var ref2 = (0,_sliced_to_array/* default */.Z)((0,AuthStore/* useAuthStore */.t)(function(state) {
        return [
            state.isLoggin,
            state.setIsLoggin,
            state.setLogginOpen,
            state.setUserInformations,
            state.userInformations,
            state.setMyAccountOpen
        ];
    }), 6), isLoggin = ref2[0], setIsLoggin = ref2[1], setLogginOpen = ref2[2], setUserInformations = ref2[3], userInformations = ref2[4], setMyAccountOpen = ref2[5];
    var t = (0,esm/* useTranslation */.$G)([
        "common",
        "nav"
    ]).t;
    var ref3 = (0,_sliced_to_array/* default */.Z)((0,ConfigurationStore/* useConfigurationStore */.w)(function(state) {
        return [
            state.setBasketCount
        ];
    }), 1), setBasketCount = ref3[0];
    var windowSize = (0,hooks/* useWindowSize */.iP)();
    var ref4 = (0,_sliced_to_array/* default */.Z)((0,GlobalStore/* useGlobalStore */.s)(function(state) {
        return [
            state.currencyType,
            state.currencyRates,
            state.isResponsible
        ];
    }), 3), currencyType = ref4[0], currencyRates = ref4[1], isResponsible = ref4[2];
    var ref5 = (0,react.useState)(0), credit = ref5[0], setCredit = ref5[1];
    var onLogout = function() {
        var guestID = localStorage.getItem("g_id");
        var userID = localStorage.getItem("u_id");
        (0,allServices/* logout */.kS)().then(function(data) {
            if (data.status === "logout") {
                setIsLoggin(false);
                setUserInformations([]);
                localStorage.clear();
                localStorage.setItem("g_id", guestID);
                localStorage.setItem("u_id", userID);
                setBasketCount(0);
                setMyAccountOpen(false);
                setLogginOpen(false);
            }
        }).catch(function(err) {
            setIsLoggin(false);
            setUserInformations([]);
            localStorage.clear();
            localStorage.setItem("g_id", guestID);
            localStorage.setItem("u_id", userID);
            setBasketCount(0);
            setMyAccountOpen(false);
            setLogginOpen(false);
        });
    };
    var goToCustomerPanel = function() {
        (0,allServices/* getRedirectToken */.pZ)().then(function(res) {
            window.open("".concat("https://panel.makdos.com/", "weblogin?token=").concat(res.access_token), "_blank");
        // window.open(
        //     `http://0.0.0.0:3001/weblogin?token=${res.access_token}`,
        //     '_blank'
        // );
        });
    };
    var wrapperRef = (0,react.useRef)(null);
    useOutsideAlerter(wrapperRef);
    (0,react.useEffect)(function() {
        (0,allServices/* getCustomerCredit */.Ql)().then(function(data) {
            setCredit(data.credit);
        });
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        ref: windowSize.width > 800 ? wrapperRef : null,
        className: "relative flex flex-col justify-center px-4 py-6 bg-white rounded-md w-96 lg:px-6 lg:shadow-md lg:border-t-4 lg:border-makdosYellow",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                className: "absolute hidden right-16 -top-3 lg:block ",
                width: "9",
                height: "8",
                viewBox: "0 0 9 8",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M3.6273 0.5C4.01517 -0.166667 4.98483 -0.166667 5.3727 0.5L8.86349 6.5C9.25136 7.16667 8.76652 8 7.99079 8H1.00921C0.233477 8 -0.251356 7.16667 0.13651 6.5L3.6273 0.5Z",
                    fill: "#FFDF0F"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "w-full mx-auto",
                children: [
                    userInformations && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("h2", {
                                className: "text-2xl font-medium text-selectboxText",
                                children: [
                                    t("common:welcome"),
                                    ", ",
                                    userInformations === null || userInformations === void 0 ? void 0 : (ref = userInformations.customer_info) === null || ref === void 0 ? void 0 : ref.customer_name,
                                    " \uD83D\uDC4B ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "text-xs",
                                        children: isResponsible ? "(" + t("authorizedLogin") + ")" : ""
                                    }),
                                    " "
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "mt-3 text-cardText",
                                children: userInformations === null || userInformations === void 0 ? void 0 : (ref1 = userInformations.customer_info) === null || ref1 === void 0 ? void 0 : ref1.customer_email
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "py-2 my-3 border-t border-b",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                            className: "text-cardText",
                            children: [
                                t("common:credit"),
                                " : ",
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                    className: "".concat(credit == 0 ? "text-discountRed" : credit < 10 ? " text-orange-400" : "text-alertGreen"),
                                    children: [
                                        (0,helpersFunc/* changeCurrency */.sy)(currencyRates, currencyType, credit),
                                        " ",
                                        currencyType
                                    ]
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                            onClick: function() {
                                return goToCustomerPanel();
                            },
                            title: "M\xfcşteri Paneli",
                            className: "flex items-center w-full px-4 py-3 font-medium transition-colors duration-300 rounded-md bg-makdosYellow hover:bg-makdosLaci hover:text-textWhite tr text-md focus:outline-none",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                    className: "mr-1 text-xl font-medium ri-dashboard-line"
                                }),
                                t("common:customerPanel")
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "mt-5",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                            onClick: function() {
                                return onLogout();
                            },
                            className: "flex items-center w-full px-4 py-3 font-medium transition-colors duration-300 rounded-md group text-textGray hover:text-discountRed text-md focus:outline-none",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                    className: "mr-1 text-xl font-medium transition-colors duration-300 ri-logout-box-line text-textGray group-hover:text-discountRed"
                                }),
                                t("common:signOut")
                            ]
                        })
                    })
                ]
            })
        ]
    });
}
/* harmony default export */ var components_MyAccount = (MyAccount);

// EXTERNAL MODULE: ./node_modules/.pnpm/react-copy-to-clipboard@5.1.0_react@18.2.0/node_modules/react-copy-to-clipboard/lib/index.js
var lib = __webpack_require__(90943);
;// CONCATENATED MODULE: ./components/SignIn/NewPasswordModal.js











function NewPasswordModal(param) {
    var onClick = param.onClick, mail = param.mail, closeModal = param.closeModal;
    var ref = (0,react.useState)(""), otp = ref[0], setOtp = ref[1];
    var ref1 = (0,react.useState)(""), pass = ref1[0], setPass = ref1[1];
    var ref2 = (0,react.useState)(""), passAgain = ref2[0], setPassAgain = ref2[1];
    var ref3 = (0,react.useState)(), generatedPassword = ref3[0], setGeneratedPassword = ref3[1];
    var ref4 = (0,react.useState)(false), showDanger = ref4[0], setShowDanger = ref4[1];
    var t = (0,esm/* useTranslation */.$G)([
        "common",
        "nav",
        "signup"
    ]).t;
    var handleChange = function(otp) {
        return setOtp(otp);
    };
    var onGeneratePassword = function() {
        var genPass = (0,helpersFunc/* generatePassword */.F2)();
        setGeneratedPassword(genPass);
        setPass(genPass);
        setPassAgain(genPass);
    };
    var copyToClipboard = function(e) {
        if (generatedPassword) {
            alert("Şifrenizi Panoya Kopyaladınız.");
        } else {
            alert("\xd6nce bir şifre giriniz.");
        }
    };
    var onChangePassword = function() {
        if (otp !== "" && pass !== "" && passAgain !== "") {
            (0,allServices/* forgotPasswordCheckCode */.ZU)(mail, otp, pass, passAgain).then(function(res) {
                if (res.status === "password_changed") {
                    onClick();
                } else {
                    if (res.message === "code_already_used") {
                        setShowDanger("Kod daha \xf6nceden kullanıldı.");
                    } else if (res.status === "code_expire") {
                        setShowDanger("Doğrulama kodunun s\xfcresi dolmuş. L\xfctfen tekrar kod alınız.");
                    } else if (res.status === "not_match" || res.message === "not_match") {
                        setShowDanger("Doğrulama kodu eşleşmiyor.");
                    } else if (res.message === "passwords_does_not_match") {
                        setShowDanger("Parola eşleşmiyor.");
                    } else if (res.message === "password_length_not_enough") {
                        setShowDanger("Parola yeterli uzunlukta değil.");
                    } else if (res.message === "password_not_valid") {
                        var ref;
                        setShowDanger(t("passwordIncompatibleError") + ((res === null || res === void 0 ? void 0 : res.available) ? " " + t("passwordCharacterError") + " " + (res === null || res === void 0 ? void 0 : (ref = res.available) === null || ref === void 0 ? void 0 : ref.join(" ")) : ""));
                    } else if (res.message === "you_are_banned") {
                        setShowDanger("Hesabınız ".concat(moment_default()(res.ban_end_time).format("DD/MM/YY HH:mm"), " tarihine kadar banlanmıştır."));
                    } else if (res.message === "account_blocked") {
                        setShowDanger("Hesabınız ".concat(moment_default()(res.ban_end_time).format("DD/MM/YY HH:mm"), " tarihine kadar banlanmıştır."));
                    } else {
                        setShowDanger("Bir hata oluştu l\xfctfen tekrar deneyiniz. \xc7\xf6z\xfclmezse destek ekibimizle iletişime ge\xe7iniz.");
                    }
                }
            });
        } else {
            setShowDanger("L\xfctfen boş alan bırakmayınız.");
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "fixed inset-0 z-50 overflow-y-auto",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "flex items-end justify-center min-h-screen pt-4 pb-20 text-center sm:block sm:p-0",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "fixed inset-0 transition-opacity",
                    "aria-hidden": "true",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "absolute inset-0 bg-gray-500 opacity-75"
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    className: "hidden sm:inline-block sm:align-middle sm:h-screen",
                    "aria-hidden": "true",
                    children: "​"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "inline-block overflow-hidden text-left align-bottom transition-all transform bg-white rounded-lg shadow-xl sm:my-8 sm:align-middle sm:max-w-lg sm:w-full",
                    role: "dialog",
                    "aria-modal": "true",
                    "aria-labelledby": "modal-headline",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "bg-white",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "sm:flex sm:items-start",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "text-center",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "flex items-center justify-between px-4 py-6 border-b-2 border-makdosSecondaryGray",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {}),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                                    className: "text-xl font-medium leading-6 text-selectboxText",
                                                    id: "modal-headline",
                                                    children: "Yeni Parola"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                        className: "text-xl cursor-pointer ri-close-line text-selectboxText",
                                                        onClick: function() {
                                                            return closeModal();
                                                        }
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "px-10 mt-8",
                                            children: [
                                                showDanger && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "mb-4 text-left",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AlertDanger/* default */.Z, {
                                                        message: showDanger
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                    className: "text-lg",
                                                    children: "Doğrulama Kodu"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "flex justify-center my-4",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Validation/* default */.ZP, {
                                                        value: otp,
                                                        onChange: function(v) {
                                                            return setOtp(v.toLocaleUpperCase("tr"));
                                                        },
                                                        autoFocus: true,
                                                        inputClassName: "text-gray-500 border border-textGray  focus:border-1 focus:border-makdosYellow focus:ring-1 focus:ring-makdosYellow focus:outline-none",
                                                        OTPLength: 6,
                                                        otpType: "string",
                                                        disabled: false,
                                                        secure: true
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                    className: "text-center text-md text-cardText",
                                                    children: "Yeni parolanızı minimum 8 karakter, b\xfcy\xfck harf, k\xfc\xe7\xfck harf, sayı ve \xf6zel karakter i\xe7erecek şekilde oluşturabilirsiniz."
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "mt-4 text-left",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconTextBox/* default */.Z, {
                                                        value: pass,
                                                        onChange: function(v) {
                                                            return setPass(v);
                                                        },
                                                        labelName: "Parola",
                                                        inputName: "password",
                                                        type: "password",
                                                        placeholder: "******",
                                                        iconChange: true,
                                                        textBoxIcon: "ri-eye-line",
                                                        textBoxSecondIcon: "ri-eye-off-line"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "mt-4 text-left",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconTextBox/* default */.Z, {
                                                        value: passAgain,
                                                        onChange: function(v) {
                                                            return setPassAgain(v);
                                                        },
                                                        labelName: t("signup:passwordAgain"),
                                                        inputName: "passwordAgain",
                                                        type: "password",
                                                        placeholder: "12345678",
                                                        iconChange: true,
                                                        textBoxIcon: "ri-eye-line",
                                                        textBoxSecondIcon: "ri-eye-off-line"
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "flex justify-between px-10 mt-4",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    onClick: function() {
                                        return onGeneratePassword();
                                    },
                                    className: "mr-5 cursor-pointer",
                                    children: "Parola Oluştur"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(lib.CopyToClipboard, {
                                    text: generatedPassword,
                                    onCopy: function() {
                                        return copyToClipboard();
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "cursor-pointer",
                                        children: "Kopyala"
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "w-full px-10 py-3 mb-5 lg:flex",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "w-full mt-5 lg:mt-4",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                    onClick: function() {
                                        return onChangePassword();
                                    },
                                    name: "go",
                                    buttonText: "Parolamı Değiştir"
                                })
                            })
                        })
                    ]
                })
            ]
        })
    });
}
/* harmony default export */ var SignIn_NewPasswordModal = (NewPasswordModal);

// EXTERNAL MODULE: ./components/GlobalModals/SuccessModal.js
var SuccessModal = __webpack_require__(51550);
;// CONCATENATED MODULE: ./layout/Header/index.js















function Header() {
    var useOutsideAlerter = //when outside of the combobox clicked, it will be closed
    function useOutsideAlerter(ref) {
        (0,react.useEffect)(function() {
            function handleClickOutside(event) {
                if (ref.current && !ref.current.contains(event.target)) {
                    closeToggles();
                }
            }
            document.addEventListener("mousedown", handleClickOutside);
            return function() {
                document.removeEventListener("mousedown", handleClickOutside);
            };
        }, [
            ref
        ]);
    };
    var t = (0,esm/* useTranslation */.$G)([
        "common",
        "nav"
    ]).t;
    var router = (0,next_router.useRouter)();
    var ref = (0,react.useState)(false), menuOpen = ref[0], setMenuOpen = ref[1];
    var ref1 = (0,_sliced_to_array/* default */.Z)((0,AuthStore/* useAuthStore */.t)(function(state) {
        return [
            state.isLoggin,
            state.logginOpen,
            state.setLogginOpen,
            state.myAccountOpen,
            state.setMyAccountOpen
        ];
    }), 5), isLoggin = ref1[0], logginOpen = ref1[1], setLogginOpen = ref1[2], myAccountOpen = ref1[3], setMyAccountOpen = ref1[4];
    var ref2 = (0,_sliced_to_array/* default */.Z)((0,ConfigurationStore/* useConfigurationStore */.w)(function(state) {
        return [
            state.basketCount
        ];
    }), 1), basketCount = ref2[0];
    var ref3 = (0,react.useState)(router.locale), lang = ref3[0], setLang = ref3[1];
    var windowSize = (0,hooks/* useWindowSize */.iP)();
    var ref4 = (0,react.useState)(false), openActivationModal = ref4[0], setOpenActivationModal = ref4[1];
    var ref5 = (0,react.useState)(false), openNewPasswordModal = ref5[0], setOpenNewPasswordModal = ref5[1];
    var ref6 = (0,react.useState)(false), openSuccessModal = ref6[0], setOpenSuccessModal = ref6[1];
    var ref7 = (0,react.useState)(), buttonText = ref7[0], setButtonText = ref7[1];
    var ref8 = (0,_sliced_to_array/* default */.Z)((0,hooks/* useToggleHeader */.Q_)(), 8), domainOpen = ref8[0], webHostingOpen = ref8[1], sunucularOpen = ref8[2], ePostaOpen = ref8[3], ekstraOpen = ref8[4], kurumsalOpen = ref8[5], toggle = ref8[6], closeToggles = ref8[7];
    // const [domainOpen, setDomainOpen] = useState(false)
    // const [webHostingOpen, setWebHostingOpen] = useState(false)
    // const [sunucularOpen, setSunucularOpen] = useState(false)
    // const [ePostaOpen, setEPostaOpen] = useState(false)
    // const [ekstraOpen, setEkstraOpen] = useState(false)
    // const [kurumsalOpen, setKurumsalOpen] = useState(false)
    var wrapperRef = (0,react.useRef)(null);
    useOutsideAlerter(wrapperRef);
    (0,react.useEffect)(function() {
        if (isLoggin) {
            setButtonText(t("common:myAccount"));
        } else {
            setButtonText(t("common:signIn"));
        }
    }, [
        isLoggin
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "sticky z-40 px-4 bg-white shadow-md -top-1",
                ref: wrapperRef,
                onMouseLeave: function() {
                    return closeToggles();
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "container mx-auto lg:px-6 md:px-0",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "py-6 border-gray-100 flexBetween lg:justify-start lg:space-x-10",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "flex justify-start lg:w-0 lg:flex-1",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                            href: "/",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                        className: "hidden lg:block",
                                                        src: "/headerLogo.svg",
                                                        alt: "headerLogo",
                                                        title: "Logo",
                                                        width: 200,
                                                        height: 73
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                        className: "block lg:hidden",
                                                        src: "/headerLogo.svg",
                                                        alt: "headerLogo",
                                                        title: "Logo",
                                                        width: 140,
                                                        height: 73
                                                    })
                                                ]
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "flex -my-2 -mr-2 lg:hidden",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "w-20 h-10 p-2 border-2 border-gray-300 border-opacity-50 rounded-lg",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                    href: "/basket",
                                                    as: t("nav:basket"),
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: "flex justify-center text-base font-medium text-gray-500 align-middle whitespace-nowrap hover:text-gray-900",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                                                                width: "17",
                                                                height: "16",
                                                                viewBox: "0 0 14 13",
                                                                fill: "none",
                                                                xmlns: "http://www.w3.org/2000/svg",
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                                    d: "M7.00001 0.333374C8.06088 0.333374 9.07829 0.754801 9.82844 1.50495C10.5786 2.25509 11 3.27251 11 4.33337V5.00004H13.6667V6.33337H12.8887L12.384 12.3887C12.3701 12.5553 12.2942 12.7106 12.1712 12.8238C12.0482 12.9371 11.8872 12.9999 11.72 13H2.28001C2.11284 12.9999 1.95181 12.9371 1.82882 12.8238C1.70584 12.7106 1.62989 12.5553 1.61601 12.3887L1.11068 6.33337H0.333344V5.00004H3.00001V4.33337C3.00001 3.27251 3.42144 2.25509 4.17158 1.50495C4.92173 0.754801 5.93914 0.333374 7.00001 0.333374ZM11.5507 6.33337H2.44868L2.89334 11.6667H11.106L11.5507 6.33337ZM7.66668 7.66671V10.3334H6.33334V7.66671H7.66668ZM5.00001 7.66671V10.3334H3.66668V7.66671H5.00001ZM10.3333 7.66671V10.3334H9.00001V7.66671H10.3333ZM7.00001 1.66671C6.31585 1.66671 5.65786 1.92966 5.16214 2.40119C4.66641 2.87272 4.37088 3.51674 4.33668 4.20004L4.33334 4.33337V5.00004H9.66668V4.33337C9.66668 3.64921 9.40372 2.99122 8.93219 2.4955C8.46067 1.99978 7.81665 1.70425 7.13334 1.67004L7.00001 1.66671Z",
                                                                    fill: "#242126"
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                className: "flex items-center justify-center w-5 h-5 ml-2 text-xs text-center bg-black rounded-full text-textWhite",
                                                                children: basketCount
                                                            })
                                                        ]
                                                    })
                                                })
                                            }),
                                            isLoggin ? /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                onClick: function() {
                                                    setMyAccountOpen(!myAccountOpen);
                                                },
                                                className: "flex items-center justify-center w-full px-1 py-1 mx-2 font-medium transition-colors duration-300 rounded-md bg-makdosYellow hover:bg-makdosLaci hover:text-textWhite tr text-md focus:outline-none",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                    className: "text-xl font-medium ri-user-line"
                                                })
                                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                onClick: function() {
                                                    setLogginOpen(!logginOpen);
                                                },
                                                className: "flex items-center justify-center w-full px-1 py-1 mx-2 font-medium transition-colors duration-300 rounded-md bg-makdosYellow hover:bg-makdosLaci hover:text-textWhite tr text-md focus:outline-none",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                    className: "text-xl font-medium ri-user-line"
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                                onClick: function() {
                                                    setMenuOpen(!menuOpen);
                                                    setLogginOpen(false);
                                                },
                                                type: "button",
                                                className: "inline-flex items-center justify-center p-2 text-gray-400 bg-white rounded-lg hover:text-gray-500 hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-indigo-500",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        className: "sr-only",
                                                        children: "Open menu"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                        className: "text-2xl ri-menu-line"
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("nav", {
                                        className: "hidden space-x-5 pr-7 lg:flex",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "relative",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                        href: "/domains",
                                                        as: t("nav:domainservices"),
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                                                onMouseOver: function() {
                                                                    return toggle("1");
                                                                },
                                                                type: "button",
                                                                className: "inline-flex items-center text-base font-medium text-gray-500 bg-white rounded-lg group hover:text-gray-900 focus:outline-none",
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                        children: t("common:domain")
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                                        className: "ri-arrow-down-s-line"
                                                                    })
                                                                ]
                                                            })
                                                        })
                                                    }),
                                                    domainOpen && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: "absolute z-10 w-screen max-w-3xl px-2 mt-3 -ml-4 transform bg-white border-t-4 rounded-md sm:px-0 lg:ml-0 lg:left-1/2 lg:-translate-x-1/2 border-makdosYellow",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                                                                className: "absolute -top-3 right-1/2",
                                                                width: "9",
                                                                height: "8",
                                                                viewBox: "0 0 9 8",
                                                                fill: "none",
                                                                xmlns: "http://www.w3.org/2000/svg",
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                                    d: "M3.6273 0.5C4.01517 -0.166667 4.98483 -0.166667 5.3727 0.5L8.86349 6.5C9.25136 7.16667 8.76652 8 7.99079 8H1.00921C0.233477 8 -0.251356 7.16667 0.13651 6.5L3.6273 0.5Z",
                                                                    fill: "#FFDF0F"
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                className: "overflow-hidden rounded-lg rounded-t-none shadow-lg ring-1 ring-black ring-opacity-5",
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                    className: "grid grid-cols-2 px-5 py-1 mt-2 mb-3 bg-white lg:gap-5",
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                                            href: "/domainsearch",
                                                                            as: t("nav:domainfind"),
                                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Header_HeaderCard, {
                                                                                    href: t("nav:domainfind"),
                                                                                    icon: "ri-search-2-line",
                                                                                    title: t("common:domainNameSearch"),
                                                                                    description: t("common:domainNameSearchDescription"),
                                                                                    as: t("nav:domainfind")
                                                                                })
                                                                            })
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                                            href: "/domaintransfer",
                                                                            as: t("nav:domaintransfer"),
                                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Header_HeaderCard, {
                                                                                    href: t("nav:domaintransfer"),
                                                                                    icon: "ri-arrow-left-right-line",
                                                                                    title: t("common:domainTransfer"),
                                                                                    description: t("common:domainTransferDescription")
                                                                                })
                                                                            })
                                                                        })
                                                                    ]
                                                                })
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "relative",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                        href: "/web-hosting",
                                                        as: t("nav:hostingservices"),
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                                                onMouseOver: function() {
                                                                    return toggle("2");
                                                                },
                                                                type: "button",
                                                                className: "inline-flex items-center text-base font-medium text-gray-500 bg-white rounded-lg group hover:text-gray-900 focus:outline-none",
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                        children: "Web Hosting"
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                                        className: "ri-arrow-down-s-line"
                                                                    })
                                                                ]
                                                            })
                                                        })
                                                    }),
                                                    webHostingOpen && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: "absolute z-10 w-screen max-w-3xl px-2 mt-3 -ml-4 transform bg-white border-t-4 rounded-md sm:px-0 lg:ml-0 lg:left-1/2 lg:-translate-x-1/2 border-makdosYellow",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                                                                className: "absolute -top-3 right-1/2",
                                                                width: "9",
                                                                height: "8",
                                                                viewBox: "0 0 9 8",
                                                                fill: "none",
                                                                xmlns: "http://www.w3.org/2000/svg",
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                                    d: "M3.6273 0.5C4.01517 -0.166667 4.98483 -0.166667 5.3727 0.5L8.86349 6.5C9.25136 7.16667 8.76652 8 7.99079 8H1.00921C0.233477 8 -0.251356 7.16667 0.13651 6.5L3.6273 0.5Z",
                                                                    fill: "#FFDF0F"
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                className: "overflow-hidden rounded-lg rounded-t-none shadow-lg ring-1 ring-black ring-opacity-5",
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                    className: "grid grid-cols-2 px-5 pt-1 pb-4 mt-2 bg-white lg:gap-4",
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                                            href: "/web-hosting/cpanel-hosting",
                                                                            as: t("nav:personalwebhosting"),
                                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Header_HeaderCard, {
                                                                                    href: t("nav:personalwebhosting"),
                                                                                    icon: "ri-user-line",
                                                                                    title: t("common:personalWebHosting"),
                                                                                    description: t("common:personalWebHostingDescription")
                                                                                })
                                                                            })
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                                            href: "/web-hosting/reseller-hosting",
                                                                            as: t("nav:resellerwebhosting"),
                                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Header_HeaderCard, {
                                                                                    href: t("nav:resellerwebhosting"),
                                                                                    icon: "ri-contacts-line",
                                                                                    title: t("common:resellerWebHosting"),
                                                                                    description: t("common:resellerWebHostingDescription")
                                                                                })
                                                                            })
                                                                        })
                                                                    ]
                                                                })
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "relative",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                        href: "/servers",
                                                        as: t("nav:serverservices"),
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                                                onMouseOver: function() {
                                                                    return toggle("3");
                                                                },
                                                                type: "button",
                                                                className: "inline-flex items-center text-base font-medium text-gray-500 bg-white rounded-lg group hover:text-gray-900 focus:outline-none",
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                        children: t("common:servers")
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                                        className: "ri-arrow-down-s-line"
                                                                    })
                                                                ]
                                                            })
                                                        })
                                                    }),
                                                    sunucularOpen && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: "absolute z-10 w-screen max-w-3xl px-2 mt-3 -ml-4 transform bg-white border-t-4 rounded-md sm:px-0 lg:ml-0 lg:left-1/2 lg:-translate-x-1/2 border-makdosYellow",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                                                                className: "absolute -top-3 right-1/2",
                                                                width: "9",
                                                                height: "8",
                                                                viewBox: "0 0 9 8",
                                                                fill: "none",
                                                                xmlns: "http://www.w3.org/2000/svg",
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                                    d: "M3.6273 0.5C4.01517 -0.166667 4.98483 -0.166667 5.3727 0.5L8.86349 6.5C9.25136 7.16667 8.76652 8 7.99079 8H1.00921C0.233477 8 -0.251356 7.16667 0.13651 6.5L3.6273 0.5Z",
                                                                    fill: "#FFDF0F"
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                className: "overflow-hidden rounded-lg rounded-t-none shadow-lg ring-1 ring-black ring-opacity-5",
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                    className: "grid grid-cols-2 px-5 py-1 mt-2 mb-2 bg-white lg:gap-5",
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                                            href: "/servers/virtual-servers",
                                                                            as: t("nav:virtualServers"),
                                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Header_HeaderCard, {
                                                                                    href: t("nav:virtualServers"),
                                                                                    icon: "ri-mac-line",
                                                                                    title: t("common:virtualServers"),
                                                                                    description: t("common:virtualServersDescription")
                                                                                })
                                                                            })
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                                            href: "/servers/dedicated",
                                                                            as: t("nav:dedicatedservers"),
                                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Header_HeaderCard, {
                                                                                    href: t("nav:dedicatedservers"),
                                                                                    icon: "ri-server-line",
                                                                                    title: t("common:dedicatedServers"),
                                                                                    description: t("common:dedicatedServersDescription")
                                                                                })
                                                                            })
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                                            href: "/servers/co-location",
                                                                            as: t("nav:colocation"),
                                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Header_HeaderCard, {
                                                                                    href: t("nav:colocation"),
                                                                                    icon: "ri-building-2-line",
                                                                                    title: t("common:co-location"),
                                                                                    description: t("common:co-locationDescription")
                                                                                })
                                                                            })
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                                            href: "/servers/cloud-servers",
                                                                            as: t("nav:cloudservers"),
                                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Header_HeaderCard, {
                                                                                    href: t("nav:cloudservers"),
                                                                                    icon: "ri-cloud-line",
                                                                                    title: t("common:cloudServers"),
                                                                                    description: t("common:cloudServersDescription")
                                                                                })
                                                                            })
                                                                        })
                                                                    ]
                                                                })
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "relative",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                        href: "/email",
                                                        as: t("nav:emailservices"),
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                                                onMouseOver: function() {
                                                                    return toggle("4");
                                                                },
                                                                type: "button",
                                                                className: "inline-flex items-center text-base font-medium text-gray-500 bg-white rounded-lg group hover:text-gray-900 focus:outline-none",
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                        children: t("common:e-mail")
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                                        className: "ri-arrow-down-s-line"
                                                                    })
                                                                ]
                                                            })
                                                        })
                                                    }),
                                                    ePostaOpen && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: "absolute z-10 w-screen max-w-3xl px-2 mt-3 -ml-4 transform bg-white border-t-4 rounded-md sm:px-0 lg:ml-0 lg:left-1/2 lg:-translate-x-1/2 border-makdosYellow",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                                                                className: "absolute -top-3 right-1/2",
                                                                width: "9",
                                                                height: "8",
                                                                viewBox: "0 0 9 8",
                                                                fill: "none",
                                                                xmlns: "http://www.w3.org/2000/svg",
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                                    d: "M3.6273 0.5C4.01517 -0.166667 4.98483 -0.166667 5.3727 0.5L8.86349 6.5C9.25136 7.16667 8.76652 8 7.99079 8H1.00921C0.233477 8 -0.251356 7.16667 0.13651 6.5L3.6273 0.5Z",
                                                                    fill: "#FFDF0F"
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                className: "overflow-hidden rounded-lg rounded-t-none shadow-lg ring-1 ring-black ring-opacity-5",
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                        className: "grid grid-cols-2 px-5 py-1 mt-2 mb-2 bg-white lg:gap-5",
                                                                        children: [
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                                                href: "/email/e-mail",
                                                                                as: t("nav:corporateemail"),
                                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Header_HeaderCard, {
                                                                                        href: t("nav:corporateemail"),
                                                                                        icon: "ri-mail-check-line",
                                                                                        title: t("common:corporateEmail"),
                                                                                        description: t("common:corporateEmailDescription")
                                                                                    })
                                                                                })
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Header_HeaderCard, {
                                                                                disable: true,
                                                                                icon: "ri-umail-send-line",
                                                                                title: t("common:emailMarketing"),
                                                                                description: t("common:emailMarketingDescription")
                                                                            })
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                        className: "grid grid-cols-2 px-5 py-1 mt-2 mb-2 bg-white lg:gap-5",
                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                                            href: "/email/iys",
                                                                            as: t("nav:iys"),
                                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Header_HeaderCard, {
                                                                                    href: t("nav:iys"),
                                                                                    icon: "ri-user-search-line",
                                                                                    title: t("common:messageManagementSystem"),
                                                                                    description: t("common:messageManagementSystemDescription")
                                                                                })
                                                                            })
                                                                        })
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "relative",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                        href: "/extra",
                                                        as: t("nav:ekstraservices"),
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                                                onMouseOver: function() {
                                                                    return toggle("5");
                                                                },
                                                                type: "button",
                                                                className: "inline-flex items-center text-base font-medium text-gray-500 bg-white rounded-lg group hover:text-gray-900 focus:outline-none",
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                        children: t("common:extra")
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                                        className: "ri-arrow-down-s-line"
                                                                    })
                                                                ]
                                                            })
                                                        })
                                                    }),
                                                    ekstraOpen && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: "absolute z-10 w-screen max-w-3xl px-2 mt-3 -ml-4 transform bg-white border-t-4 rounded-md sm:px-0 lg:ml-0 lg:left-1/2 lg:-translate-x-1/2 border-makdosYellow",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                                                                className: "absolute -top-3 right-1/2",
                                                                width: "9",
                                                                height: "8",
                                                                viewBox: "0 0 9 8",
                                                                fill: "none",
                                                                xmlns: "http://www.w3.org/2000/svg",
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                                    d: "M3.6273 0.5C4.01517 -0.166667 4.98483 -0.166667 5.3727 0.5L8.86349 6.5C9.25136 7.16667 8.76652 8 7.99079 8H1.00921C0.233477 8 -0.251356 7.16667 0.13651 6.5L3.6273 0.5Z",
                                                                    fill: "#FFDF0F"
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                className: "overflow-hidden rounded-lg rounded-t-none shadow-lg ring-1 ring-black ring-opacity-5",
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                        className: "grid grid-cols-2 px-5 py-1 mt-2 bg-white lg:gap-5",
                                                                        children: [
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                                                href: "/extra/ssl-certificates",
                                                                                as: t("nav:sslcertificates"),
                                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Header_HeaderCard, {
                                                                                        href: t("nav:sslcertificates"),
                                                                                        icon: "ri-lock-2-line",
                                                                                        title: t("common:SSLCertificate"),
                                                                                        description: t("common:SSLCertificateDescription")
                                                                                    })
                                                                                })
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                                                href: "/extra/control-panels",
                                                                                as: t("nav:controlpanel"),
                                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Header_HeaderCard, {
                                                                                        href: t("nav:controlpanel"),
                                                                                        icon: "ri-window-2-line",
                                                                                        title: t("common:controlPanelLicance"),
                                                                                        description: t("common:controlPanelLicanceDescription")
                                                                                    })
                                                                                })
                                                                            })
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                        className: "grid grid-cols-2 px-5 py-1 mt-2 mb-2 bg-white lg:gap-5",
                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                                            href: "/extra/firewall-and-security",
                                                                            as: t("nav:firewallandsecurity"),
                                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Header_HeaderCard, {
                                                                                    href: t("nav:firewallandsecurity"),
                                                                                    icon: "ri-shield-check-line",
                                                                                    title: t("common:firewallAndSecurity"),
                                                                                    description: t("common:firewallAndSecurityDescription")
                                                                                })
                                                                            })
                                                                        })
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "relative",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                        href: "/aboutusservices",
                                                        as: t("nav:corporate"),
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                                                onMouseOver: function() {
                                                                    return toggle("6");
                                                                },
                                                                type: "button",
                                                                className: "inline-flex items-center text-base font-medium text-gray-500 bg-white rounded-lg group hover:text-gray-900 focus:outline-none",
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                        children: t("common:corporate")
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                                        className: "ri-arrow-down-s-line"
                                                                    })
                                                                ]
                                                            })
                                                        })
                                                    }),
                                                    kurumsalOpen && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: "absolute z-10 w-screen max-w-3xl px-2 mt-3 -ml-4 transform bg-white border-t-4 rounded-md sm:px-0 lg:ml-0 lg:left-1/2 lg:-translate-x-1/2 border-makdosYellow",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                                                                className: "absolute -top-3 right-1/2",
                                                                width: "9",
                                                                height: "8",
                                                                viewBox: "0 0 9 8",
                                                                fill: "none",
                                                                xmlns: "http://www.w3.org/2000/svg",
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                                    d: "M3.6273 0.5C4.01517 -0.166667 4.98483 -0.166667 5.3727 0.5L8.86349 6.5C9.25136 7.16667 8.76652 8 7.99079 8H1.00921C0.233477 8 -0.251356 7.16667 0.13651 6.5L3.6273 0.5Z",
                                                                    fill: "#FFDF0F"
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                className: "overflow-hidden rounded-lg rounded-t-none shadow-lg ring-1 ring-black ring-opacity-5",
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                        className: "grid grid-cols-2 px-5 py-1 mt-2 bg-white lg:gap-5",
                                                                        children: [
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                                                href: "/corporate/about-us",
                                                                                as: t("nav:aboutus"),
                                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Header_HeaderCard, {
                                                                                        href: t("nav:aboutus"),
                                                                                        icon: "ri-community-line",
                                                                                        title: t("common:aboutUs"),
                                                                                        description: t("common:aboutUsDescription")
                                                                                    })
                                                                                })
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                                                href: "/corporate/financial-and-commercial-information",
                                                                                as: t("nav:financialinformation"),
                                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Header_HeaderCard, {
                                                                                        href: t("nav:financialinformation"),
                                                                                        icon: "ri-safe-line",
                                                                                        title: t("common:financialInformation"),
                                                                                        description: t("common:financialInformationDescription")
                                                                                    })
                                                                                })
                                                                            })
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                        className: "grid grid-cols-2 px-5 py-1 mt-2 mb-2 bg-white lg:gap-5",
                                                                        children: [
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                                                href: "/corporate/infrastructure",
                                                                                as: t("nav:ourinfrastructure"),
                                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Header_HeaderCard, {
                                                                                        href: t("nav:ourinfrastructure"),
                                                                                        icon: "ri-building-4-line",
                                                                                        title: t("common:infrastructure"),
                                                                                        description: t("common:infrastructureDescription")
                                                                                    })
                                                                                })
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                                                href: "/corporate/contact",
                                                                                as: t("nav:contactus"),
                                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Header_HeaderCard, {
                                                                                        href: t("nav:contactus"),
                                                                                        icon: "ri-chat-quote-line",
                                                                                        title: t("common:contact"),
                                                                                        description: t("common:contactDescription")
                                                                                    })
                                                                                })
                                                                            })
                                                                        ]
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "items-center justify-end hidden lg:flex lg:flex-1 lg:w-0",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                href: "/basket",
                                                as: t("nav:basket"),
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "flex items-center justify-center w-20 h-12 p-2 border-2 border-gray-300 border-opacity-50 rounded-lg cursor-pointer",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            className: "flex items-center justify-center py-1 font-medium text-gray-500 hover:text-gray-900",
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                                    className: "text-2xl text-black ri-shopping-basket-line"
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                    className: "flex items-center justify-center w-5 h-5 ml-2 text-xs font-medium text-center bg-black rounded-full text-textWhite",
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                        children: basketCount
                                                                    })
                                                                })
                                                            ]
                                                        })
                                                    })
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "relative",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "ml-2",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                                            onClick: function() {
                                                                isLoggin ? setMyAccountOpen(!myAccountOpen) : setLogginOpen(!logginOpen);
                                                            },
                                                            buttonText: buttonText,
                                                            buttonLeftIcon: "ri-user-line"
                                                        })
                                                    }),
                                                    logginOpen && !isLoggin && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "absolute z-10 w-screen max-w-xs px-2 mt-3 duration-500 transform -translate-x-1/2 -left-20 sm:px-0 animate-[pulse_1s_ease-in-out_1]",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SignIn_SignIn, {
                                                            setOpenNewPasswordModal: function(v) {
                                                                return setOpenNewPasswordModal(v);
                                                            }
                                                        })
                                                    }),
                                                    isLoggin && myAccountOpen && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "absolute z-10 w-screen max-w-xs px-2 mt-3 transform -translate-x-1/2 -left-20 sm:px-0",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_MyAccount, {})
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }),
                            (windowSize === null || windowSize === void 0 ? void 0 : windowSize.width) < 800 && isLoggin && myAccountOpen && !menuOpen && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "mt-5",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_MyAccount, {})
                            }),
                            (windowSize === null || windowSize === void 0 ? void 0 : windowSize.width) < 800 && !isLoggin && logginOpen && !menuOpen && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "mt-5",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SignIn_SignIn, {
                                    setOpenNewPasswordModal: function(v) {
                                        return setOpenNewPasswordModal(v);
                                    }
                                })
                            })
                        ]
                    }),
                    menuOpen && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "absolute inset-x-0 top-0 p-2 transition origin-top-right transform lg:hidden",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "bg-white divide-y-2 rounded-lg rounded-t-none shadow-lg divide-gray-50 ring-1 ring-black ring-opacity-5",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "h-screen px-5 pt-5 pb-6 overflow-y-auto",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "flexBetween",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                href: "/",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                        className: "w-auto h-8 sm:h-10",
                                                        src: "/headerLogo.png",
                                                        alt: "headerLogo",
                                                        title: "Logo",
                                                        width: 160,
                                                        height: 43
                                                    })
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "flex -mr-2",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "w-20 h-10 p-2 border-2 border-gray-300 border-opacity-50 rounded-lg",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                            href: "/basket",
                                                            as: t("nav:basket"),
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                onClick: function() {
                                                                    return setMenuOpen(!menuOpen);
                                                                },
                                                                className: "flex justify-center text-base font-medium text-gray-500 align-middle hover:text-gray-900",
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                                                                        width: "17",
                                                                        height: "16",
                                                                        viewBox: "0 0 14 13",
                                                                        fill: "none",
                                                                        xmlns: "http://www.w3.org/2000/svg",
                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                                            d: "M7.00001 0.333374C8.06088 0.333374 9.07829 0.754801 9.82844 1.50495C10.5786 2.25509 11 3.27251 11 4.33337V5.00004H13.6667V6.33337H12.8887L12.384 12.3887C12.3701 12.5553 12.2942 12.7106 12.1712 12.8238C12.0482 12.9371 11.8872 12.9999 11.72 13H2.28001C2.11284 12.9999 1.95181 12.9371 1.82882 12.8238C1.70584 12.7106 1.62989 12.5553 1.61601 12.3887L1.11068 6.33337H0.333344V5.00004H3.00001V4.33337C3.00001 3.27251 3.42144 2.25509 4.17158 1.50495C4.92173 0.754801 5.93914 0.333374 7.00001 0.333374ZM11.5507 6.33337H2.44868L2.89334 11.6667H11.106L11.5507 6.33337ZM7.66668 7.66671V10.3334H6.33334V7.66671H7.66668ZM5.00001 7.66671V10.3334H3.66668V7.66671H5.00001ZM10.3333 7.66671V10.3334H9.00001V7.66671H10.3333ZM7.00001 1.66671C6.31585 1.66671 5.65786 1.92966 5.16214 2.40119C4.66641 2.87272 4.37088 3.51674 4.33668 4.20004L4.33334 4.33337V5.00004H9.66668V4.33337C9.66668 3.64921 9.40372 2.99122 8.93219 2.4955C8.46067 1.99978 7.81665 1.70425 7.13334 1.67004L7.00001 1.66671Z",
                                                                            fill: "#242126"
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                        className: "flex items-center justify-center w-5 h-5 ml-2 text-xs text-center bg-black rounded-full text-textWhite",
                                                                        children: basketCount
                                                                    })
                                                                ]
                                                            })
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                                        onClick: function() {
                                                            return setMenuOpen(!menuOpen);
                                                        },
                                                        type: "button",
                                                        className: "inline-flex items-center justify-center p-2 text-gray-400 bg-white rounded-lg hover:text-gray-500 hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-indigo-500",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                className: "sr-only",
                                                                children: "Close menu"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                                                                className: "w-6 h-6",
                                                                xmlns: "http://www.w3.org/2000/svg",
                                                                fill: "none",
                                                                viewBox: "0 0 24 24",
                                                                stroke: "currentColor",
                                                                "aria-hidden": "true",
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                                    strokeLinecap: "round",
                                                                    strokeLinejoin: "round",
                                                                    strokeWidth: 2,
                                                                    d: "M6 18L18 6M6 6l12 12"
                                                                })
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    !logginOpen && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "mt-6",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        onClick: function() {
                                                            return toggle("1", true);
                                                        },
                                                        className: "p-2 flexBetween",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                className: "font-medium",
                                                                children: t("common:domain")
                                                            }),
                                                            !domainOpen ? /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                                className: "text-2xl ri-arrow-right-s-line"
                                                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                                className: "text-2xl ri-arrow-up-s-line"
                                                            })
                                                        ]
                                                    }),
                                                    domainOpen && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: "flex flex-col mt-5",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                                href: "/domainsearch",
                                                                as: t("nav:domainfind"),
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Header_HeaderCard, {
                                                                        icon: "ri-search-2-line",
                                                                        title: t("common:domainNameSearch"),
                                                                        description: t("common:domainNameSearchDescription")
                                                                    })
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                                href: "/domaintransfer",
                                                                as: t("nav:domaintransfer"),
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Header_HeaderCard, {
                                                                        icon: "ri-arrow-left-right-line",
                                                                        title: t("common:domainTransfer"),
                                                                        description: t("common:domainTransferDescription")
                                                                    })
                                                                })
                                                            }),
                                                            ","
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "mt-6",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        onClick: function() {
                                                            return toggle("2", true);
                                                        },
                                                        className: "p-2 flexBetween",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                className: "font-medium",
                                                                children: "Web Hosting"
                                                            }),
                                                            !webHostingOpen ? /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                                className: "text-2xl ri-arrow-right-s-line"
                                                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                                className: "text-2xl ri-arrow-up-s-line"
                                                            })
                                                        ]
                                                    }),
                                                    webHostingOpen && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: "flex flex-col mt-5",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                                href: "/web-hosting/cpanel-hosting",
                                                                as: t("nav:personalwebhosting"),
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Header_HeaderCard, {
                                                                        icon: "ri-user-line",
                                                                        title: t("common:personalWebHosting"),
                                                                        description: t("common:personalWebHostingDescription")
                                                                    })
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                                href: "/web-hosting/reseller-hosting",
                                                                as: t("nav:resellerwebhosting"),
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Header_HeaderCard, {
                                                                        icon: "ri-contacts-line",
                                                                        title: t("common:resellerWebHosting"),
                                                                        description: t("common:resellerWebHostingDescription")
                                                                    })
                                                                })
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "mt-6",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        onClick: function() {
                                                            return toggle("3", true);
                                                        },
                                                        className: "p-2 flexBetween",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                className: "font-medium",
                                                                children: t("common:servers")
                                                            }),
                                                            !sunucularOpen ? /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                                className: "text-2xl ri-arrow-right-s-line"
                                                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                                className: "text-2xl ri-arrow-up-s-line"
                                                            })
                                                        ]
                                                    }),
                                                    sunucularOpen && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: "flex flex-col mt-5",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                                href: "/servers/virtual-servers",
                                                                as: t("nav:virtualServers"),
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Header_HeaderCard, {
                                                                        href: t("nav:virtualServers"),
                                                                        icon: "ri-mac-line",
                                                                        title: t("common:virtualServers"),
                                                                        description: t("common:virtualServersDescription")
                                                                    })
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                                href: "/servers/dedicated",
                                                                as: t("nav:dedicatedservers"),
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Header_HeaderCard, {
                                                                        icon: "ri-server-line",
                                                                        title: t("common:dedicatedServers"),
                                                                        description: t("common:dedicatedServersDescription")
                                                                    })
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                                href: "/servers/co-location",
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Header_HeaderCard, {
                                                                        icon: "ri-building-2-line",
                                                                        title: t("common:co-location"),
                                                                        description: t("common:co-locationDescription")
                                                                    })
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                                href: "/servers/cloud-servers",
                                                                as: t("nav:cloudservers"),
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Header_HeaderCard, {
                                                                        href: t("nav:cloudservers"),
                                                                        icon: "ri-cloud-line",
                                                                        title: t("common:cloudServers"),
                                                                        description: t("common:cloudServersDescription")
                                                                    })
                                                                })
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "mt-6",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        onClick: function() {
                                                            return toggle("4", true);
                                                        },
                                                        className: "p-2 flexBetween",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                className: "font-medium",
                                                                children: t("common:e-mail")
                                                            }),
                                                            !ePostaOpen ? /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                                className: "text-2xl ri-arrow-right-s-line"
                                                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                                className: "text-2xl ri-arrow-up-s-line"
                                                            })
                                                        ]
                                                    }),
                                                    ePostaOpen && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: "flex flex-col mt-5",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                                href: "/email/e-mail",
                                                                as: t("nav:corporateemail"),
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Header_HeaderCard, {
                                                                        icon: "ri-mail-check-line",
                                                                        title: t("common:corporateEmail"),
                                                                        description: t("common:corporateEmailDescription")
                                                                    })
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Header_HeaderCard, {
                                                                disable: true,
                                                                icon: "ri-umail-send-line",
                                                                title: t("common:emailMarketing"),
                                                                description: t("common:emailMarketingDescription")
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                                href: "/email/iys",
                                                                as: t("nav:iys"),
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Header_HeaderCard, {
                                                                        icon: "ri-user-search-line",
                                                                        title: t("common:messageManagementSystem"),
                                                                        description: t("common:messageManagementSystemDescription")
                                                                    })
                                                                })
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "mt-6",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        onClick: function() {
                                                            return toggle("5", true);
                                                        },
                                                        className: "p-2 flexBetween",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                className: "font-medium",
                                                                children: t("common:extra")
                                                            }),
                                                            !ekstraOpen ? /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                                className: "text-2xl ri-arrow-right-s-line"
                                                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                                className: "text-2xl ri-arrow-up-s-line"
                                                            })
                                                        ]
                                                    }),
                                                    ekstraOpen && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: "flex flex-col mt-5",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                                href: "/extra/ssl-certificates",
                                                                as: t("nav:sslcertificates"),
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Header_HeaderCard, {
                                                                        icon: "ri-lock-2-line",
                                                                        title: t("common:SSLCertificate"),
                                                                        description: t("common:SSLCertificateDescription")
                                                                    })
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                                href: "/extra/control-panels",
                                                                as: t("nav:controlpanel"),
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Header_HeaderCard, {
                                                                        icon: "ri-window-2-line",
                                                                        title: t("common:controlPanelLicance"),
                                                                        description: t("common:ControlPanelLicanceDescription")
                                                                    })
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                                href: "/extra/firewall-and-security",
                                                                as: t("nav:firewallandsecurity"),
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Header_HeaderCard, {
                                                                        icon: "ri-shield-check-line",
                                                                        title: t("common:firewallAndSecurity"),
                                                                        description: t("common:firewallAndSecurityDescription")
                                                                    })
                                                                })
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "mt-6",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        onClick: function() {
                                                            return toggle("6", true);
                                                        },
                                                        className: "p-2 flexBetween",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                className: "font-medium",
                                                                children: t("common:corporate")
                                                            }),
                                                            !kurumsalOpen ? /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                                className: "text-2xl ri-arrow-right-s-line"
                                                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                                className: "text-2xl ri-arrow-up-s-line"
                                                            })
                                                        ]
                                                    }),
                                                    kurumsalOpen && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: "flex flex-col mt-5",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                                href: "/corporate/about-us",
                                                                as: t("nav:aboutus"),
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Header_HeaderCard, {
                                                                        icon: "ri-community-line",
                                                                        title: t("common:aboutUs"),
                                                                        description: t("common:aboutUsDescription")
                                                                    })
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                                href: "/corporate/financial-and-commercial-information",
                                                                as: t("nav:financialinformation"),
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Header_HeaderCard, {
                                                                        icon: "ri-safe-line",
                                                                        title: t("common:financialInformation"),
                                                                        description: t("common:financialInformationDescription")
                                                                    })
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                                href: "/corporate/infrastructure",
                                                                as: t("nav:ourinfrastructure"),
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Header_HeaderCard, {
                                                                        icon: "ri-building-4-line",
                                                                        title: t("common:infrastructure"),
                                                                        description: t("common:infrastructureDescription")
                                                                    })
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                                href: "/corporate/contact",
                                                                as: t("nav:contactus"),
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Header_HeaderCard, {
                                                                        icon: "ri-chat-quote-line",
                                                                        title: t("common:contact"),
                                                                        description: t("common:infrastructureDescription")
                                                                    })
                                                                })
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            })
                        })
                    })
                ]
            }),
            openNewPasswordModal && /*#__PURE__*/ (0,jsx_runtime.jsx)(SignIn_NewPasswordModal, {
                mail: openNewPasswordModal,
                setOpenModal: function() {
                    return setOpenActivationModal(false);
                },
                onClick: function() {
                    setOpenSuccessModal(true);
                    setOpenNewPasswordModal(false);
                },
                closeModal: function() {
                    setOpenNewPasswordModal(false);
                }
            }),
            openSuccessModal && /*#__PURE__*/ (0,jsx_runtime.jsx)(SuccessModal/* default */.Z, {
                title: "Parola Değiştirildi",
                message: "Yeni parolanız ile birlikte hesabınıza giriş yapabilirsiniz.",
                onClick: function() {
                    return setOpenSuccessModal(false);
                },
                setOpenModal: function() {
                    return setOpenSuccessModal(false);
                },
                buttonText: "Tamam"
            })
        ]
    });
}
/* harmony default export */ var layout_Header = (Header);

// EXTERNAL MODULE: ./node_modules/.pnpm/next@12.3.4_react-dom@18.2.0_react@18.2.0/node_modules/next/image.js
var next_image = __webpack_require__(70649);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
;// CONCATENATED MODULE: ./layout/Footer/index.js






function Footer() {
    var router = (0,next_router.useRouter)();
    var t = (0,esm/* useTranslation */.$G)([
        "common",
        "nav"
    ]).t;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "border-t-2 Footer border-makdosSecondaryGray",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "container flex items-center py-6 mx-auto footerTop",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "items-center justify-between w-full px-4 lg:flex lg:px-0",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "logo",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                src: "/headerLogo.svg",
                                alt: "footer-logo",
                                title: "Footer Logo",
                                width: 186,
                                height: 50
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "grid grid-cols-3 gap-5 lg:gap-x-10",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "flex flex-col col-span-3 mt-2 lg:col-span-1 lg:mt-0",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "mb-1 text-xs text-textGray",
                                            children: t("customerServices")
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                            className: "text-lg font-bold",
                                            href: "tel:+908503077744",
                                            children: "(+90) 850 307 77 44"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "flex flex-col col-span-3 mt-2 lg:col-span-1 lg:mt-0",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "mb-1 text-xs text-textGray",
                                            children: "E-Mail"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                            className: "text-lg font-bold",
                                            href: "mailto:info@makdos.com",
                                            children: "info@makdos.com"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "flex flex-col col-span-3 mt-2 lg:col-span-1 lg:mt-0",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "mb-1 text-xs text-textGray",
                                            children: t("socialMedia")
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "flex",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                    className: "mr-2",
                                                    href: "https://github.com/MakdosBilisim",
                                                    target: "__blank",
                                                    title: "Github",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                        className: "text-2xl ri-github-fill"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                    className: "mr-2",
                                                    href: "https://www.linkedin.com/company/makdos/",
                                                    target: "__blank",
                                                    title: "Linkedin",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                        className: "text-2xl ri-linkedin-fill"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                    className: "mr-2",
                                                    href: "https://www.instagram.com/makdos.cloud/",
                                                    target: "__blank",
                                                    title: "İnstagram",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                        className: "text-2xl ri-instagram-fill"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                    className: "mr-2",
                                                    href: "https://www.youtube.com/channel/UChJNsK-9r-dDkgBP8FHxwMA",
                                                    target: "__blank",
                                                    title: "Youtube",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                        className: "text-2xl ri-youtube-fill"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                    className: "mr-2",
                                                    href: "https://twitter.com/MakdosCloud",
                                                    target: "__blank",
                                                    title: "Twitter",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                        className: "text-xl ri-twitter-x-fill"
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("hr", {
                className: "text-makdosSecondaryGray"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "container items-center px-4 py-6 mx-auto mb-3 footerContent sm:px-6",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "grid grid-cols-12",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "footerColspanStyle",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "mt-5 mb-2",
                                    children: t("common:domainNameServices")
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                    href: "/domainsearch",
                                    as: t("nav:domainfind"),
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        className: "footerLinkTextStyle",
                                        children: t("common:domainNameSearch")
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                    href: "/domaintransfer",
                                    as: t("nav:domaintransfer"),
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        className: "footerLinkTextStyle",
                                        children: t("common:domainTransfer")
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "footerColspanStyle",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "mt-5 mb-2",
                                    children: "Web Hosting"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                    href: "/web-hosting/cpanel-hosting",
                                    as: t("nav:personalwebhosting"),
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        className: "footerLinkTextStyle",
                                        children: "Web Hosting"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "footerLinkTextStyle",
                                    children: t("common:resellerWebHosting")
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "footerColspanStyle",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "mt-5 mb-2",
                                    children: t("common:serverServices")
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                    href: "/servers/cloud/virtual-servers",
                                    as: t("nav:virtualServers"),
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        className: "footerLinkTextStyle",
                                        children: t("common:virtualServers")
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                    href: "/servers/cloud",
                                    as: t("nav:cloudservers"),
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        className: "footerLinkTextStyle",
                                        children: t("common:cloudServers")
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                    href: "/servers/dedicated",
                                    as: t("nav:dedicatedservers"),
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        className: "footerLinkTextStyle",
                                        children: t("common:dedicatedServers")
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                    href: "/servers/co-location",
                                    as: t("nav:colocation"),
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        className: "footerLinkTextStyle",
                                        children: t("common:co-location")
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "footerColspanStyle",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "mt-5 mb-2",
                                    children: t("common:extra")
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                    href: "/extra/control-panels",
                                    as: t("nav:controlpanel"),
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        className: "footerLinkTextStyle",
                                        children: t("common:controlPanelLicance")
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                    href: "/extra/ssl-certificates",
                                    as: t("nav:sslcertificates"),
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        className: "footerLinkTextStyle",
                                        children: t("common:SSLCertificate")
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                    href: "/extra/firewall-and-security",
                                    as: t("nav:firewallandsecurity"),
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        className: "footerLinkTextStyle",
                                        children: t("common:firewallAndSecurity")
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "footerColspanStyle",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "mt-5 mb-2",
                                    children: t("common:contracts")
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                    href: "/contracts/user-agreement",
                                    as: t("nav:userAgreement"),
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        className: "footerLinkTextStyle",
                                        children: t("common:userAgreement")
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                    href: "/contracts/privacy-policy",
                                    as: t("nav:privacyPolicy"),
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        className: "footerLinkTextStyle",
                                        children: t("common:privacyPolicy")
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                    href: "/contracts/refund-policy",
                                    as: t("nav:refundPolicy"),
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        className: "footerLinkTextStyle",
                                        children: t("common:refundPolicy")
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                    href: "/contracts/general-term-of-use",
                                    as: t("nav:termsOfUse"),
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        className: "footerLinkTextStyle",
                                        children: t("common:termsOfUse")
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                    href: "/contracts/information-security-policy",
                                    as: t("nav:informationSecurityPolicy"),
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        className: "footerLinkTextStyle",
                                        children: t("common:informationSecurityPolicy")
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "footerColspanStyle",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "mt-5 mb-2",
                                    children: t("common:corporate")
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                    href: "/corporate/about-us",
                                    as: t("nav:aboutus"),
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        className: "footerLinkTextStyle",
                                        children: t("common:aboutUs")
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                    href: "/corporate/financial-and-commercial-information",
                                    as: t("nav:financialinformation"),
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        className: "footerLinkTextStyle",
                                        children: t("common:financialInformation")
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                    href: "/corporate/infrastructure",
                                    as: t("nav:ourinfrastructure"),
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        className: "footerLinkTextStyle",
                                        children: t("common:infrastructure")
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                    href: "/help",
                                    as: t("nav:help"),
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        className: "items-center footerLinkTextStyle",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            children: t("common:help")
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    className: "items-center footerLinkTextStyle",
                                    href: "https://makdos.blog/",
                                    target: "_blank",
                                    children: "Makdos Blog"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                    href: "/corporate/contact",
                                    as: t("nav:contactus"),
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        className: "footerLinkTextStyle",
                                        children: t("common:contact")
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "flex items-center space-x-2",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                            href: "/tr/",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                src: "/langTR.png",
                                                alt: "turkey",
                                                title: "Turkey",
                                                width: "20",
                                                height: "13"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                            href: "/en/",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                src: "/langEN.png",
                                                alt: "english",
                                                title: "English",
                                                width: "20",
                                                height: "13"
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "items-center px-4 mx-auto text-center footerBottom sm:px-6 bg-makdosSecondaryGray",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                    className: "py-3 text-xs text-textGray",
                    children: [
                        "Makdos Bilişim Teknolojileri 2015 - 2025 ",
                        t("common:allRightsReserved")
                    ]
                })
            })
        ]
    });
}
/* harmony default export */ var layout_Footer = (Footer);

// EXTERNAL MODULE: ./node_modules/.pnpm/react-cookie@4.1.1_react@18.2.0/node_modules/react-cookie/es6/useCookies.js + 6 modules
var useCookies = __webpack_require__(15113);
;// CONCATENATED MODULE: ./components/TopHeader/Language.js








function Language() {
    var ref = (0,react.useState)(false), openLanguage = ref[0], setOpenLanguage = ref[1];
    var ref1 = (0,_sliced_to_array/* default */.Z)((0,hooks/* useCloseSelectBox */.SB)(setOpenLanguage), 1), wrapperRef = ref1[0];
    var router = (0,next_router.useRouter)();
    var ref2 = (0,_sliced_to_array/* default */.Z)((0,useCookies/* default */.Z)([
        "NEXT_LOCALE"
    ]), 2), cookie = ref2[0], setCookie = ref2[1];
    var ref3 = (0,react.useState)(router.locale ? router.locale : router.query.language ? router.query.language : "tr"), selectedLanguage = ref3[0], setSelectedLanguage = ref3[1];
    var ref4 = (0,_sliced_to_array/* default */.Z)((0,GlobalStore/* useGlobalStore */.s)(function(state) {
        return [
            state.otherCategoriesWiki,
            state.otherArticleWiki,
            state.otherArticles,
            state.otherCategories
        ];
    }), 4), otherCategoriesWiki = ref4[0], otherArticleWiki = ref4[1], otherArticles = ref4[2], otherCategories = ref4[3];
    var changeLanguage = function(e) {
        setSelectedLanguage(e);
        setOpenLanguage(!openLanguage);
        // router.push(`${locale}${router.pathname}`, `${locale}${router.pathname}`, { locale });
        if (!router.pathname.includes("/help/[category]") && !router.pathname.startsWith("/blog")) {
            if (cookie.NEXT_LOCALE !== e) {
                setCookie("NEXT_LOCALE", e, {
                    path: "/"
                });
            }
            var pageList = [
                {
                    asPageURL: "/tr/",
                    pageURL: "/"
                },
                {
                    asPageURL: "/en/",
                    pageURL: "/"
                },
                {
                    asPageURL: "/en/sign-up",
                    pageURL: "/signup"
                },
                {
                    asPageURL: "/tr/kayit-ol",
                    pageURL: "/signup"
                },
                //configuration
                {
                    asPageURL: "/en/configuration",
                    pageURL: "/configuration"
                },
                {
                    asPageURL: "/tr/yapilandirma",
                    pageURL: "/configuration"
                },
                //basket
                {
                    asPageURL: "/en/basket",
                    pageURL: "/basket"
                },
                {
                    asPageURL: "/tr/sepet",
                    pageURL: "/basket"
                },
                //domain
                {
                    asPageURL: "/en/domains",
                    pageURL: "/domains"
                },
                {
                    asPageURL: "/tr/alanadi",
                    pageURL: "/domains"
                },
                {
                    asPageURL: "/en/search-domain",
                    pageURL: "/domainsearch"
                },
                {
                    asPageURL: "/tr/alanadi-sorgulama",
                    pageURL: "/domainsearch"
                },
                {
                    asPageURL: "/en/domain-transfer",
                    pageURL: "/domaintransfer"
                },
                {
                    asPageURL: "/tr/alanadi-transfer",
                    pageURL: "/domaintransfer"
                },
                //web-hostings
                {
                    asPageURL: "/en/web-hosting",
                    pageURL: "/web-hosting"
                },
                {
                    asPageURL: "/tr/web-hosting",
                    pageURL: "/web-hosting"
                },
                {
                    asPageURL: "/en/web-hosting/cpanel-hosting",
                    pageURL: "/web-hosting/cpanel-hosting"
                },
                {
                    asPageURL: "/tr/web-hosting/cpanel-hosting",
                    pageURL: "/web-hosting/cpanel-hosting"
                },
                {
                    asPageURL: "/en/corporate-web-hosting",
                    pageURL: "/corporatewebhosting"
                },
                {
                    asPageURL: "/tr/kurumsal-web-hosting",
                    pageURL: "/corporatewebhosting"
                },
                //servers
                {
                    asPageURL: "/en/servers",
                    pageURL: "/servers"
                },
                {
                    asPageURL: "/tr/sunucular",
                    pageURL: "/servers"
                },
                {
                    asPageURL: "/en/servers/virtual-servers",
                    pageURL: "/servers/virtual-servers"
                },
                {
                    asPageURL: "/tr/sunucular/sanal-sunucular",
                    pageURL: "/servers/virtual-servers"
                },
                {
                    asPageURL: "/en/servers/cloud/windows",
                    pageURL: "/servers/cloud/windows"
                },
                {
                    asPageURL: "/tr/sunucular/sanal/windows",
                    pageURL: "/servers/cloud/windows"
                },
                {
                    asPageURL: "/en/servers/cloud/linux",
                    pageURL: "/servers/cloud/linux"
                },
                {
                    asPageURL: "/tr/sunucular/sanal/linux",
                    pageURL: "/servers/cloud/linux"
                },
                {
                    asPageURL: "/en/servers/cloud-servers",
                    pageURL: "/servers/cloud-servers"
                },
                {
                    asPageURL: "/tr/sunucular/bulut",
                    pageURL: "/servers/cloud-servers"
                },
                {
                    asPageURL: "/en/servers/dedicated",
                    pageURL: "/servers/dedicated"
                },
                {
                    asPageURL: "/tr/sunucular/fiziksel",
                    pageURL: "/servers/dedicated"
                },
                //E-MAİL
                {
                    asPageURL: "/en/email",
                    pageURL: "/email"
                },
                {
                    asPageURL: "/tr/eposta",
                    pageURL: "/email"
                },
                {
                    asPageURL: "/en/email/mail",
                    pageURL: "/email/mail"
                },
                {
                    asPageURL: "/tr/eposta/kurumsal-eposta",
                    pageURL: "/email/mail"
                },
                {
                    asPageURL: "/en/email/iys",
                    pageURL: "/email/iys"
                },
                {
                    asPageURL: "/tr/eposta/iys",
                    pageURL: "/email/iys"
                },
                //Ekstra
                {
                    asPageURL: "/en/extra",
                    pageURL: "/extra"
                },
                {
                    asPageURL: "/tr/ekstra",
                    pageURL: "/extra"
                },
                {
                    asPageURL: "/en/extra/ssl-certificates",
                    pageURL: "/extra/ssl-certificates"
                },
                {
                    asPageURL: "/tr/ekstra/ssl-sertifikalari",
                    pageURL: "/extra/ssl-certificates"
                },
                {
                    asPageURL: "/en/extra/firewall-security",
                    pageURL: "/extra/firewall-and-security"
                },
                {
                    asPageURL: "/tr/ekstra/firewall-guvenlik",
                    pageURL: "/extra/firewall-and-security"
                },
                {
                    asPageURL: "/en/extra/control-panels",
                    pageURL: "/extra/control-panels"
                },
                {
                    asPageURL: "/tr/ekstra/kontrol-panelleri",
                    pageURL: "/extra/control-panels"
                },
                //corporate
                {
                    asPageURL: "/en/corporate/about-us",
                    pageURL: "/corporate/about-us"
                },
                {
                    asPageURL: "/tr/kurumsal/hakkimizda",
                    pageURL: "/corporate/about-us"
                },
                {
                    asPageURL: "/en/corporate",
                    pageURL: "/aboutusservices"
                },
                {
                    asPageURL: "/tr/kurumsal",
                    pageURL: "/aboutusservices"
                },
                {
                    asPageURL: "/en/servers/co-location",
                    pageURL: "/servers/co-location"
                },
                {
                    asPageURL: "/tr/sunucular/barindirma",
                    pageURL: "/servers/co-location"
                },
                {
                    asPageURL: "/en/corporate/financial-and-commercial-information",
                    pageURL: "/corporate/financial-and-commercial-information"
                },
                {
                    asPageURL: "/tr/kurumsal/finansal-ve-ticari-bilgiler",
                    pageURL: "/corporate/financial-and-commercial-information"
                },
                {
                    asPageURL: "/en/corporate/infrastructure",
                    pageURL: "/corporate/infrastructure"
                },
                {
                    asPageURL: "/tr/kurumsal/alt-yapimiz",
                    pageURL: "/corporate/infrastructure"
                },
                {
                    asPageURL: "/en/corporate/contact",
                    pageURL: "/corporate/contact"
                },
                {
                    asPageURL: "/tr/kurumsal/iletisim",
                    pageURL: "/corporate/contact"
                },
                {
                    asPageURL: "/en/contracts",
                    pageURL: "/contracts"
                },
                {
                    asPageURL: "/tr/sozlesmeler",
                    pageURL: "/contracts"
                },
                {
                    asPageURL: "/en/contracts/user-agreement",
                    pageURL: "/contracts/user-agreement"
                },
                {
                    asPageURL: "/tr/sozlesmeler/kullanici-sozlesmesi",
                    pageURL: "/contracts/user-agreement"
                },
                {
                    asPageURL: "/en/contracts/refund-policy",
                    pageURL: "/contracts/refund-policy"
                },
                {
                    asPageURL: "/tr/sozlesmeler/iade-sartlari",
                    pageURL: "/contracts/refund-policy"
                },
                {
                    asPageURL: "/en/contracts/privacy-policy",
                    pageURL: "/contracts/privacy-policy"
                },
                {
                    asPageURL: "/tr/sozlesmeler/gizlilik-politikasi",
                    pageURL: "/contracts/privacy-policy"
                },
                {
                    asPageURL: "/en/contracts/general-term-of-use",
                    pageURL: "/contracts/general-term-of-use"
                },
                {
                    asPageURL: "/tr/sozlesmeler/genel-kullanim-kosullari",
                    pageURL: "/contracts/general-term-of-use"
                },
                {
                    asPageURL: "/en/contracts/information-security-policy",
                    pageURL: "/contracts/information-security-policy"
                },
                {
                    asPageURL: "/tr/sozlesmeler/bilgi-guvenligi-politikasi",
                    pageURL: "/contracts/information-security-policy"
                },
                {
                    asPageURL: "/en/help",
                    pageURL: "/help"
                },
                {
                    asPageURL: "/tr/yardim",
                    pageURL: "/help"
                },
                {
                    asPageURL: "/en/web-hosting/reseller-hosting",
                    pageURL: "/web-hosting/reseller-hosting"
                },
                {
                    asPageURL: "/tr/web-hosting/reseller-hosting",
                    pageURL: "/web-hosting/reseller-hosting"
                }, 
            ];
            var pageToRedirect = pageList.find(function(x) {
                return x.pageURL.includes(router.pathname) && x.asPageURL.startsWith("/" + e);
            });
            var activePage = pageList.filter(function(x) {
                return x.pageURL.includes(pageToRedirect.pageURL) && x.asPageURL !== pageToRedirect.asPageURL;
            })[0];
            router.push(activePage.pageURL, pageToRedirect.asPageURL.startsWith("/tr") ? pageToRedirect.asPageURL.substr(3, pageToRedirect.asPageURL.length) : pageToRedirect.asPageURL, {
                locale: e
            });
        } else if (router.pathname.includes("/help/[category]")) {
            if (router.pathname === "/help/[category]") {
                setSelectedLanguage(e);
                if (otherCategoriesWiki.length > 0) {
                    if (otherCategoriesWiki.find(function(x) {
                        return x.language_name === e;
                    })) {
                        var findData = otherCategoriesWiki.find(function(x) {
                            return x.language_name === e;
                        });
                        var mainUrl = e === "tr" ? "yardim" : "help";
                        router.push("/".concat(mainUrl, "/").concat(findData.slug), "/".concat(mainUrl, "/").concat(findData.slug), {
                            locale: e
                        });
                    }
                } else {
                    setSelectedLanguage(e);
                    var mainSlug = e === "tr" ? "yardim" : "help";
                    router.push("/".concat(mainSlug), "/".concat(mainSlug), {
                        locale: e
                    });
                }
            } else if (router.pathname === "/help/[category]/[connection_id]/[article_detail]") {
                if (otherArticleWiki.length > 0) {
                    if (otherArticleWiki.find(function(x) {
                        return x.language_name === e;
                    })) {
                        setSelectedLanguage(e);
                        var findData1 = otherArticleWiki.find(function(x) {
                            return x.language_name === e;
                        });
                        var mainUrl1 = e === "tr" ? "yardim" : "help";
                        router.push("/".concat(mainUrl1, "/").concat(findData1.category_slug, "/").concat(findData1.connection_id, "/").concat(findData1.slug), "/".concat(mainUrl1, "/").concat(findData1.category_slug, "/").concat(findData1.connection_id, "/").concat(findData1.slug), {
                            locale: e
                        });
                    }
                } else {
                    setSelectedLanguage(e);
                    var mainSlug1 = e === "tr" ? "yardim" : "help";
                    router.push("/".concat(mainSlug1), "/".concat(mainSlug1), {
                        locale: e
                    });
                }
            } else if (router.pathname === "/help/[category]/search") {
                setSelectedLanguage(e);
                var mainSlug2 = e === "tr" ? "yardim" : "help";
                router.push("/".concat(mainSlug2), "/".concat(mainSlug2), {
                    locale: e
                });
            } else if (router.pathname === "/help/[category]/arama") {
                setSelectedLanguage(e);
                var mainSlug3 = e === "tr" ? "yardim" : "help";
                router.push("/".concat(mainSlug3), "/".concat(mainSlug3), {
                    locale: e
                });
            } else {
                setSelectedLanguage(e);
                router.push("".concat(e).concat(router.pathname), {
                    locale: e
                });
            }
        } else if (router.pathname.startsWith("/blog")) {
            // Blog
            if (router.asPath.split("?")[0] === "/blog/tr/" || router.asPath.split("?")[0] === "/blog/en/") {
                setSelectedLanguage(e);
                var path = {};
                if (e === "tr") {
                    path = router.asPath.split("?")[0].replace("/en", "/tr");
                } else {
                    path = router.asPath.split("?")[0].replace("/tr", "/en");
                }
                router.push(path);
            } else if (router.pathname === "/blog/[language]/[category]/[connection_id]/[article_slug]") {
                setSelectedLanguage(e);
                if (otherArticles.length > 0) {
                    if (otherArticles.find(function(x) {
                        return x.language === e;
                    })) {
                        var findData2 = otherArticles.find(function(x) {
                            return x.language === e;
                        });
                        router.push("/blog/".concat(findData2.language, "/").concat(findData2.category_slug, "/").concat(router.query.connection_id, "/").concat(findData2.slug));
                    } else {
                        router.push("/blog/".concat(e));
                    }
                } else {
                    router.push("/blog/".concat(e));
                }
            } else if (router.pathname === "/blog/[language]/[category]") {
                setSelectedLanguage(e);
                if (otherCategories.length > 0) {
                    if (otherCategories.find(function(x) {
                        return x.language === e;
                    })) {
                        var findData3 = otherCategories.find(function(x) {
                            return x.language === e;
                        });
                        router.push("/blog/".concat(findData3.language, "/").concat(findData3.slug));
                    } else {
                        router.push("/blog/".concat(e));
                    }
                } else {
                    router.push("/blog/".concat(e));
                }
            } else if (router.pathname === "/blog/[language]/search") {
                setSelectedLanguage(e);
                router.push("/blog/".concat(e));
            } else if (router.pathname === "/blog/[language]/arama") {
                setSelectedLanguage(e);
                router.push("/blog/".concat(e));
            } else {
                setSelectedLanguage(e);
                router.push("/blog/".concat(e));
            }
        }
    };
    (0,react.useEffect)(function() {
        if (selectedLanguage === "default") {
            setSelectedLanguage(router.query.language ? router.query.language : router.locale ? router.locale : "tr");
        }
    }, [
        selectedLanguage
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "relative inline-block text-left",
        ref: wrapperRef,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                    type: "button",
                    onClick: function() {
                        return setOpenLanguage(!openLanguage);
                    },
                    className: "z-50 inline-flex items-center justify-center w-full h-10 px-3 py-1 text-sm font-medium text-gray-700 bg-white border-2 rounded-lg border-makdosSecondaryGray hover:bg-gray-50 focus:outline-none",
                    id: "options-menu-language",
                    "aria-haspopup": "true",
                    "aria-expanded": "true",
                    children: [
                        selectedLanguage === "tr" ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "flex items-center",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "mt-1 lg:mr-1",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                        src: "/langTR.png",
                                        alt: "turkey",
                                        title: "Turkey",
                                        width: "20",
                                        height: "13"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "hidden lg:block",
                                    children: "TR"
                                })
                            ]
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "flex items-center",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "mt-1 lg:mr-1",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                        src: "/langEN.png",
                                        alt: "english",
                                        title: "English",
                                        width: "20",
                                        height: "13"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "hidden lg:block",
                                    children: "EN"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                            className: "w-5 h-5 ml-2 -mr-1",
                            xmlns: "http://www.w3.org/2000/svg",
                            viewBox: "0 0 20 20",
                            fill: "currentColor",
                            "aria-hidden": "true",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                fillRule: "evenodd",
                                d: "M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z",
                                clipRule: "evenodd"
                            })
                        })
                    ]
                })
            }),
            openLanguage && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "absolute left-0 z-50 w-32 mt-2 origin-top-left bg-white rounded-lg shadow-lg ring-opacity-5",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "py-1",
                    role: "menu",
                    "aria-orientation": "vertical",
                    "aria-labelledby": "options-menu",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                            type: "button",
                            onClick: function() {
                                return changeLanguage("tr");
                            },
                            className: "flex items-center justify-center w-full px-4 py-2 text-sm font-medium text-gray-700 bg-white border-b-2 border-makdosSecondaryGray hover:bg-gray-50 focus:outline-none",
                            id: "options-menu-tr",
                            "aria-haspopup": "true",
                            "aria-expanded": "true",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "mt-1 mr-1",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                        src: "/langTR.png",
                                        alt: "lang-tr",
                                        title: "TR",
                                        width: "20",
                                        height: "13"
                                    })
                                }),
                                "TR"
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                            type: "button",
                            onClick: function() {
                                return changeLanguage("en");
                            },
                            className: "headerCurrency",
                            id: "options-menu-en",
                            "aria-haspopup": "true",
                            "aria-expanded": "true",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "mt-1 mr-1",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                        src: "/langEN.png",
                                        alt: "lang-en",
                                        title: "EN",
                                        width: "20",
                                        height: "13"
                                    })
                                }),
                                "EN"
                            ]
                        })
                    ]
                })
            })
        ]
    });
}

// EXTERNAL MODULE: ./node_modules/.pnpm/react-loader-spinner@4.0.0_react-dom@18.2.0_react@18.2.0/node_modules/react-loader-spinner/dist/index.js
var dist = __webpack_require__(56538);
;// CONCATENATED MODULE: ./components/TopHeader/Currency.js






function Currency() {
    var ref = (0,react.useState)(false), openCurrency = ref[0], setOpenCurrency = ref[1];
    var ref1 = (0,_sliced_to_array/* default */.Z)((0,hooks/* useCloseSelectBox */.SB)(setOpenCurrency), 1), wrapperRef = ref1[0];
    var ref2 = (0,_sliced_to_array/* default */.Z)((0,GlobalStore/* useGlobalStore */.s)(function(state) {
        return [
            state.currencyType,
            state.setCurrencyType
        ];
    }), 2), currencyType = ref2[0], setCurrencyType = ref2[1];
    var ref3 = (0,react.useState)(), currencyText = ref3[0], setCurrencyText = ref3[1];
    var ref4 = (0,react.useState)(true), isLoading = ref4[0], setIsLoading = ref4[1];
    var ref5 = (0,react.useState)(""), currencySymbol = ref5[0], setCurrencySymbol = ref5[1];
    var ref6 = (0,react.useState)(""), currencyLabel = ref6[0], setCurrencyLabel = ref6[1];
    var onSetCurrencyType = function(value) {
        setOpenCurrency(!openCurrency);
        setCurrencyType(value);
    };
    (0,react.useEffect)(function() {
        if (currencyType === "₺") {
            setCurrencySymbol("₺");
            setCurrencyLabel("TRY");
        } else if (currencyType === "$") {
            setCurrencySymbol("$");
            setCurrencyLabel("USD");
        } else {
            setCurrencySymbol("€");
            setCurrencyLabel("EUR");
        }
        setIsLoading(false);
    }, [
        currencyType
    ]);
    // useEffect(() => {
    //   setCurrencyText(currencyType === "₺" ? " ₺ TRY" : (currencyType === "$" ? "$ USD" : "€ EUR"));
    //   setIsLoading(false);
    // }, [currencyType]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "relative inline-block text-left",
        ref: wrapperRef,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                    type: "button",
                    onClick: function() {
                        return setOpenCurrency(!openCurrency);
                    },
                    className: "z-50 inline-flex items-center justify-center w-full h-10 px-3 py-1 text-sm font-medium text-gray-700 bg-white border-2 rounded-lg border-makdosSecondaryGray hover:bg-gray-50 focus:outline-none",
                    id: "options-menu-currency",
                    "aria-haspopup": "true",
                    "aria-expanded": "true",
                    children: [
                        isLoading ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "flex flex-col items-center justify-center",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* default */.Z, {
                                type: "Oval",
                                color: "#FFDD00",
                                height: 10,
                                width: 10,
                                timeout: 1000
                            })
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "inline sm:hidden",
                                    children: currencySymbol
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                    className: "hidden sm:inline",
                                    children: [
                                        currencySymbol,
                                        " ",
                                        currencyLabel
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                            className: "ri-arrow-down-s-line"
                        })
                    ]
                })
            }),
            openCurrency && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "absolute left-0 z-50 w-32 mt-2 origin-top-left bg-white rounded-lg shadow-lg ring-opacity-5",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "py-1",
                    role: "menu",
                    "aria-orientation": "vertical",
                    "aria-labelledby": "options-menu",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                            type: "button",
                            name: "₺",
                            onClick: function(e) {
                                return onSetCurrencyType(e.target.name);
                            },
                            className: "inline-flex items-center justify-center w-full px-4 py-2 text-sm font-medium text-gray-700 bg-white border-b-2 border-makdosSecondaryGray hover:bg-gray-50 focus:outline-none",
                            id: "options-menu1",
                            "aria-haspopup": "true",
                            "aria-expanded": "true",
                            children: "₺ TRY"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                            type: "button",
                            name: "$",
                            onClick: function(e) {
                                return onSetCurrencyType(e.target.name);
                            },
                            className: "headerCurrency",
                            id: "options-menu2",
                            "aria-haspopup": "true",
                            "aria-expanded": "true",
                            children: "$ USD"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                            type: "button",
                            name: "€",
                            onClick: function(e) {
                                return onSetCurrencyType(e.target.name);
                            },
                            className: "headerCurrency",
                            id: "options-menu3",
                            "aria-haspopup": "true",
                            "aria-expanded": "true",
                            children: "€ EUR"
                        })
                    ]
                })
            })
        ]
    });
}
/* harmony default export */ var TopHeader_Currency = (Currency);

;// CONCATENATED MODULE: ./layout/TopHeader/index.js







function TopHeader() {
    var t = (0,esm/* useTranslation */.$G)([
        "common",
        "nav",
        "homepage",
        "help"
    ]).t;
    var router = (0,next_router.useRouter)();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "w-full bg-white",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "container z-50 justify-between py-1 mx-auto bg-white flexCenter",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "flex",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Language, {}),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "ml-2",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TopHeader_Currency, {})
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                            className: "flex mr-2 space-x-2 lg:mr-0 lg:space-x-5",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                    className: "flexCenter",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                            className: " text-textGray ri-headphone-line"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                            className: "mt-0.5 ml-1 text-xs text-textGray",
                                            href: "tel:+908503077744",
                                            target: "_blank",
                                            children: "0850 307 77 44"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                    className: "flexCenter",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                            className: " text-textGray ri-mail-line"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                            className: "ml-1 text-xs text-textGray",
                                            href: "mailto:info@makdos.com",
                                            target: "_blank",
                                            children: t("common:contact")
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                    className: "flex items-center",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                            className: "mr-1 ri-book-open-line text-textGray"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                            className: "text-xs text-textGray",
                                            href: function() {
                                                var currentPath = router.asPath;
                                                if (currentPath.includes("/blog/tr")) {
                                                    return "/blog/tr/";
                                                } else if (currentPath.includes("/blog/en")) {
                                                    return "/blog/en/";
                                                } else {
                                                    return "/blog/".concat(router.locale || "", "/");
                                                }
                                            }(),
                                            target: "_blank",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                className: "",
                                                children: "Blog"
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                    className: "items-center hidden lg:flex",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                        href: "/help",
                                        as: t("nav:help"),
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                            className: "items-center hidden lg:flex",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                    className: "text-textGray ri-question-line"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                    className: "ml-1 text-xs text-textGray",
                                                    children: t("common:help")
                                                })
                                            ]
                                        })
                                    })
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "w-full border border-gray-100"
                })
            ]
        })
    });
}
/* harmony default export */ var layout_TopHeader = (TopHeader);

;// CONCATENATED MODULE: ./layout/Layout/index.js










var layoutStyle = {
    display: "flex",
    flexDirection: "column",
    height: "100%",
    width: "100%"
};
var contentStyle = {
    flex: 1,
    display: "flex",
    flexDirection: "column"
};
function Layout(props) {
    var ref = (0,_sliced_to_array/* default */.Z)((0,ConfigurationStore/* useConfigurationStore */.w)(function(state) {
        return [
            state.checkLocalStorage,
            state.setBasketCount
        ];
    }), 2), checkLocalStorage = ref[0], setBasketCount = ref[1];
    var ref1 = (0,_sliced_to_array/* default */.Z)((0,AuthStore/* useAuthStore */.t)(function(state) {
        return [
            state.checkLocalStorageAuth,
            state.isLoggin,
            state.setIsLoggin
        ];
    }), 3), checkLocalStorageAuth = ref1[0], isLoggin = ref1[1], setIsLoggin = ref1[2];
    var ref2 = (0,_sliced_to_array/* default */.Z)((0,GlobalStore/* useGlobalStore */.s)(function(state) {
        return [
            state.checkLocalStorageGlobal,
            state.setCurrencyRates
        ];
    }), 2), checkLocalStorageGlobal = ref2[0], setCurrencyRates = ref2[1];
    (0,react.useEffect)(function() {
        checkLocalStorageAuth();
        checkLocalStorage();
        checkLocalStorageGlobal();
        // getCurrencyRates().then(data => {
        //   setCurrencyRates(data);
        // }).catch(err => {
        //   console.log(err);
        //   setIsLoggin(false);
        // });
        if (isLoggin) {
            (0,allServices/* getBasketCount */.cH)().then(function(data) {
                setBasketCount(data.count);
            }).catch(function(err) {
                var ref;
                setBasketCount(0);
                if ((err === null || err === void 0 ? void 0 : (ref = err.request) === null || ref === void 0 ? void 0 : ref.status) === 401) {
                    var guestID = localStorage.getItem("g_id");
                    var userID = localStorage.getItem("u_id");
                    setIsLoggin(false);
                    localStorage.clear();
                    localStorage.setItem("g_id", guestID);
                    localStorage.setItem("u_id", userID);
                }
            });
        } else {
            setBasketCount(0);
        }
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "Layout",
        style: layoutStyle,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(layout_TopHeader, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(layout_Header, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "Content",
                style: contentStyle,
                children: props.children
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(layout_Footer, {})
        ]
    });
}
/* harmony default export */ var layout_Layout = (Layout);


/***/ }),

/***/ 20363:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "w": function() { return /* binding */ useConfigurationStore; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(57389);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(9970);
/* harmony import */ var zustand__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(31171);
/* harmony import */ var zustand_middleware__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(47299);
/* harmony import */ var local_storage__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(475);
/* harmony import */ var local_storage__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(local_storage__WEBPACK_IMPORTED_MODULE_0__);





var useConfigurationStore = (0,zustand__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,zustand_middleware__WEBPACK_IMPORTED_MODULE_2__/* .devtools */ .mW)(function(set, get) {
    var _obj;
    return _obj = {
        configurationTotal: [],
        configuration: [],
        componentValues: [],
        addComponentItem: function(id, CompName, price, count, componentId, selectBoxName, configurationName, compOrder, raid, displayName, details) {
            if (get().componentValues.length === 0) {
                set(function(state) {
                    return {
                        componentValues: (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(get().componentValues).concat([
                            {
                                id: id,
                                CompName: CompName,
                                price: price,
                                count: count,
                                componentId: componentId,
                                selectBoxName: selectBoxName,
                                configurationName: configurationName,
                                compOrder: compOrder,
                                raid: raid,
                                displayName: displayName,
                                details: details
                            }
                        ])
                    };
                });
                get().componentValues.sort(function(a, b) {
                    return a.compOrder - b.compOrder;
                });
            } else {
                var isExist = false;
                get().componentValues.map(function(c, i) {
                    if (c.CompName === CompName && c.selectBoxName === selectBoxName) isExist = true;
                    if (i + 1 === get().componentValues.length && isExist === false) {
                        set(function(state) {
                            return {
                                componentValues: (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(get().componentValues).concat([
                                    {
                                        id: id,
                                        CompName: CompName,
                                        price: price,
                                        count: count,
                                        componentId: componentId,
                                        selectBoxName: selectBoxName,
                                        configurationName: configurationName,
                                        compOrder: compOrder,
                                        raid: raid,
                                        displayName: displayName,
                                        details: details
                                    }
                                ])
                            };
                        });
                        get().componentValues.sort(function(a, b) {
                            return a.compOrder - b.compOrder;
                        });
                    }
                });
            }
            get().addToLocalStorage();
        },
        addComponent: function(id, name, group, productId, productName) {
            if (get().configuration.length === 0) {
                set(function(state) {
                    return {
                        configuration: (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(get().configuration).concat([
                            {
                                id: id,
                                name: name,
                                group: group,
                                productId: productId,
                                productName: productName
                            }
                        ])
                    };
                });
            } else {
                var isExist = false;
                get().configuration.map(function(c, i) {
                    if (c.id === id) isExist = true;
                    if (i + 1 === get().configuration.length && isExist === false) {
                        set(function(state) {
                            return {
                                configuration: (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(get().configuration).concat([
                                    {
                                        id: id,
                                        name: name,
                                        group: group,
                                        productId: productId,
                                        productName: productName
                                    }
                                ])
                            };
                        });
                    }
                });
            }
            get().addToLocalStorage();
        },
        addProduct: function(id, name) {
            if (get().configurationTotal.length === 0) {
                set(function(state) {
                    return {
                        configurationTotal: (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(get().configurationTotal).concat([
                            {
                                id: id,
                                name: name
                            }
                        ])
                    };
                });
            } else {
                var isExist = false;
                get().configurationTotal.map(function(c, i) {
                    if (c.id === id) isExist = true;
                    if (i + 1 === get().configurationTotal.length && isExist === false) {
                        set(function(state) {
                            return {
                                configurationTotal: (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(get().configurationTotal).concat([
                                    {
                                        id: id,
                                        name: name
                                    }
                                ])
                            };
                        });
                    }
                });
            }
            get().addToLocalStorage();
        },
        removeComponentItemWithSelectBoxName: function(selectBoxName, compId) {
            var newList = [];
            get().componentValues.map(function(item) {
                if (item.selectBoxName !== selectBoxName) {
                    newList.push(item);
                }
            });
            set(function(state) {
                return {
                    componentValues: newList
                };
            });
            get().addToLocalStorage();
        },
        clearComponentValues: function() {
            set(function(state) {
                return {
                    componentValues: []
                };
            });
            get().addToLocalStorage();
        },
        removeComponentItem: function(name) {
            set(function(state) {
                return {
                    componentValues: get().componentValues.filter(function(c) {
                        return c.CompName !== name;
                    })
                };
            });
            get().addToLocalStorage();
        },
        removeComponent: function(id) {
            set(function(state) {
                return {
                    configuration: get().configuration.filter(function(c) {
                        return c.id !== id;
                    })
                };
            });
            get().componentValues.map(function(x) {
                if (x.componentId === id) get().removeComponentItemWithSelectBoxName(x.selectBoxName);
            });
            get().addToLocalStorage();
        },
        removeProduct: function(id) {
            set(function(state) {
                return {
                    configurationTotal: get().configurationTotal.filter(function(c) {
                        return c.id !== id;
                    })
                };
            });
            get().configuration.map(function(x) {
                if (x.productId === id) get().removeComponent(x.id);
            });
            get().addToLocalStorage();
        },
        selectedDisk1: [],
        addSelectedDisk1: function(id, CompName, price, count, componentId, selectBoxName, configurationName, compOrder, raid, diskSize, displayName, details) {
            set(function(state) {
                return {
                    selectedDisk1: [
                        {
                            id: id,
                            CompName: CompName,
                            price: price,
                            count: count,
                            componentId: componentId,
                            selectBoxName: selectBoxName,
                            configurationName: configurationName,
                            compOrder: compOrder,
                            raid: raid,
                            diskSize: diskSize,
                            displayName: displayName,
                            details: details
                        }
                    ]
                };
            });
            get().addToLocalStorage();
        },
        deleteSelectedDisk1: function() {
            set(function(state) {
                return {
                    selectedDisk1: []
                };
            });
            get().addToLocalStorage();
        },
        selectedDisk2: [],
        addSelectedDisk2: function(id, CompName, price, count, componentId, selectBoxName, configurationName, compOrder, raid, diskSize, details) {
            set(function(state) {
                return {
                    selectedDisk2: [
                        {
                            id: id,
                            CompName: CompName,
                            price: price,
                            count: count,
                            componentId: componentId,
                            selectBoxName: selectBoxName,
                            configurationName: configurationName,
                            compOrder: compOrder,
                            raid: raid,
                            diskSize: diskSize,
                            details: details
                        }
                    ]
                };
            });
            get().addToLocalStorage();
        },
        deleteSelectedDisk2: function() {
            set(function(state) {
                return {
                    selectedDisk2: []
                };
            });
            get().addToLocalStorage();
        },
        selectedOS: null,
        setSelectedOS: function(item) {
            set(function(state) {
                return {
                    selectedOS: item
                };
            });
            get().addToLocalStorage();
        },
        selectedSubOS: null,
        setSelectedSubOS: function(item) {
            set(function(state) {
                return {
                    selectedSubOS: item
                };
            });
            get().addToLocalStorage();
        },
        backupStack: [
            {
                raid_level: null,
                disk_size: null,
                number_of_disk: null
            },
            {
                raid_level: null,
                disk_size: null,
                number_of_disk: null
            },
            {
                raid_level: null,
                disk_size: null,
                number_of_disk: null
            }
        ],
        addBackupStack: function(selectBoxId, backupRequired) {
            if (selectBoxId === "1") {
                var tmp = [];
                tmp.push(backupRequired);
                tmp.push(get().backupStack[1]);
                tmp.push(get().backupStack[2]);
                set(function(state) {
                    return {
                        backupStack: tmp
                    };
                });
            } else if (selectBoxId === "2") {
                var tmp1 = [];
                tmp1.push(get().backupStack[0]);
                tmp1.push(backupRequired);
                tmp1.push(get().backupStack[2]);
                set(function(state) {
                    return {
                        backupStack: tmp1
                    };
                });
            } else {
                var tmp2 = [];
                tmp2.push(get().backupStack[0]);
                tmp2.push(get().backupStack[1]);
                tmp2.push(backupRequired);
                set(function(state) {
                    return {
                        backupStack: tmp2
                    };
                });
            }
            get().addToLocalStorage();
        },
        removeBackupStackWithSelectBoxId: function(selectBoxId) {
            if (selectBoxId === "1") {
                var tmp = [
                    {
                        raid_level: null,
                        disk_size: null,
                        number_of_disk: null
                    }
                ];
                tmp.push(get().backupStack[1]);
                tmp.push(get().backupStack[2]);
                set(function(state) {
                    return {
                        backupStack: tmp
                    };
                });
            } else if (selectBoxId === "2") {
                var tmp1 = [];
                tmp1.push(get().backupStack[0]);
                tmp1.push({
                    raid_level: null,
                    disk_size: null,
                    number_of_disk: null
                });
                tmp1.push(get().backupStack[2]);
                set(function(state) {
                    return {
                        backupStack: tmp1
                    };
                });
            }
            get().addToLocalStorage();
        },
        backupPrice: 0,
        setBackupPrice: function(price) {
            set(function(state) {
                return {
                    backupPrice: price
                };
            });
            get().addToLocalStorage();
        },
        wafPrice: 0,
        setWafPrice: function(price) {
            set(function(state) {
                return {
                    wafPrice: price
                };
            });
            get().addToLocalStorage();
        },
        IPSPrice: 0,
        setIPSPrice: function(price) {
            set(function(state) {
                return {
                    IPSPrice: price
                };
            });
            get().addToLocalStorage();
        },
        DDOSPrice: [],
        setDDOSPrice: function(price) {
            set(function(state) {
                return {
                    DDOSPrice: price
                };
            });
            get().addToLocalStorage();
        },
        SelectedDDOSPrice: [],
        setSelectedDDOSPrice: function(price) {
            set(function(state) {
                return {
                    SelectedDDOSPrice: price
                };
            });
            get().addToLocalStorage();
        },
        OSPrice: [],
        setOSPrice: function(price) {
            set(function(state) {
                return {
                    OSPrice: price
                };
            });
            get().addToLocalStorage();
        },
        DBPrice: [],
        setDBPrice: function(price) {
            set(function(state) {
                return {
                    DBPrice: price
                };
            });
            get().addToLocalStorage();
        },
        totalCpuCore: local_storage__WEBPACK_IMPORTED_MODULE_0__.get("__totalCpuCore") || 0,
        setTotalCpuCore: function(cpuCore) {
            set(function(state) {
                return {
                    totalCpuCore: cpuCore
                };
            });
            get().addToLocalStorage();
        },
        selectedCpu: local_storage__WEBPACK_IMPORTED_MODULE_0__.get("__selectedCpu") || null,
        setSelectedCpu: function(cpu) {
            set(function(state) {
                return {
                    selectedCpu: cpu
                };
            });
            get().addToLocalStorage();
        },
        selectedFirewall: local_storage__WEBPACK_IMPORTED_MODULE_0__.get("__selectedFirewall") || null,
        setSelectedFirewall: function(fw) {
            set(function(state) {
                return {
                    selectedFirewall: fw
                };
            });
            get().addToLocalStorage();
        },
        selectedServer: local_storage__WEBPACK_IMPORTED_MODULE_0__.get("__selectedServer") || null,
        setSelectedServer: function(id) {
            set(function(state) {
                return {
                    selectedServer: id,
                    configurationTotal: [],
                    configuration: [],
                    componentValues: []
                };
            });
            get().addToLocalStorage();
        },
        defaultPaymentCycle: "one_month",
        setDefaultPaymentCycle: function(price) {
            if (price === 1) {
                set(function() {
                    return {
                        defaultPaymentCycle: "one_month"
                    };
                });
            } else if (price === 3) {
                set(function() {
                    return {
                        defaultPaymentCycle: "three_month"
                    };
                });
            } else if (price === 6) {
                set(function() {
                    return {
                        defaultPaymentCycle: "six_month"
                    };
                });
            } else if (price === 12) {
                set(function() {
                    return {
                        defaultPaymentCycle: "one_year"
                    };
                });
            } else if (price === 24) {
                set(function() {
                    return {
                        defaultPaymentCycle: "two_year"
                    };
                });
            } else if (price === 36) {
                set(function() {
                    return {
                        defaultPaymentCycle: "three_year"
                    };
                });
            }
            localStorage.setItem("__defaultPaymentCycle", JSON.stringify(get().defaultPaymentCycle));
        },
        basketCount: 0,
        setBasketCount: function(count) {
            set(function(state) {
                return {
                    basketCount: count
                };
            });
            get().addToLocalStorage();
        },
        basketTimeChange: false,
        setBasketTimeChange: function(value) {
            set(function(state) {
                return {
                    basketTimeChange: value
                };
            });
        },
        controlPanelDetails: {},
        setControlPanelDetails: function(details) {
            set(function(state) {
                return {
                    controlPanelDetails: details
                };
            });
            get().addToLocalStorage();
        },
        configurationNote: "",
        setConfigurationNote: function(value) {
            set(function(state) {
                return {
                    configurationNote: value
                };
            });
            get().addToLocalStorage();
        },
        coLocationBackupPrice: local_storage__WEBPACK_IMPORTED_MODULE_0__.get("__configurationType") ? local_storage__WEBPACK_IMPORTED_MODULE_0__.get("__configurationType") : "no-select",
        setConfigurationType: function(type) {
            set(function(state) {
                return {
                    configurationType: type
                };
            });
            get().addToLocalStorage();
        }
    }, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_obj, "coLocationBackupPrice", 0), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_obj, "setCoLocationBackupPrice", function(price) {
        set(function(state) {
            return {
                coLocationBackupPrice: price
            };
        });
        get().addToLocalStorage();
    }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_obj, "selectedYear", {}), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_obj, "setSelectedYear", function(year) {
        set(function(state) {
            return {
                selectedYear: year
            };
        });
        get().addToLocalStorage();
    }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_obj, "clearAllConfigurations", function() {
        set(function(state) {
            return {
                configurationTotal: [],
                configuration: [],
                componentValues: [],
                selectedDisk1: [],
                selectedDisk2: [],
                selectedOS: null,
                selectedSubOS: null,
                wafPrice: 0,
                ıpsPrice: 0,
                SelectedDDOSPrice: [],
                selectedCpu: null,
                selectedFirewall: null,
                configurationNote: "",
                backupStack: [
                    {
                        raid_level: null,
                        disk_size: null,
                        number_of_disk: null
                    },
                    {
                        raid_level: null,
                        disk_size: null,
                        number_of_disk: null
                    },
                    {
                        raid_level: null,
                        disk_size: null,
                        number_of_disk: null
                    }
                ],
                backupPrice: 0,
                coLocationBackupPrice: 0,
                selectedYear: 0,
                defaultPaymentCycle: "one_month",
                controlPanelDetails: {}
            };
        });
        get().setWafPrice(0);
        get().setIPSPrice(0);
        get().setDDOSPrice([]);
        get().addToLocalStorage();
    }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_obj, "addToLocalStorage", function() {
        localStorage.removeItem("__products");
        localStorage.removeItem("__configuration");
        localStorage.removeItem("__componentValues");
        localStorage.removeItem("__selectedDisk1");
        localStorage.removeItem("__selectedDisk2");
        localStorage.removeItem("backupStack");
        localStorage.setItem("__products", JSON.stringify(get().configurationTotal));
        localStorage.setItem("__configuration", JSON.stringify(get().configuration));
        localStorage.setItem("__componentValues", JSON.stringify(get().componentValues));
        localStorage.setItem("__selectedDisk1", JSON.stringify(get().selectedDisk1));
        localStorage.setItem("__selectedDisk2", JSON.stringify(get().selectedDisk2));
        localStorage.setItem("__backupStack", JSON.stringify(get().backupStack));
        localStorage.setItem("__wafPrice", JSON.stringify(get().wafPrice));
        localStorage.setItem("__IPSPrice", JSON.stringify(get().IPSPrice));
        localStorage.setItem("__DDOSPrice", JSON.stringify(get().DDOSPrice));
        localStorage.setItem("__SelectedDDOSPrice", JSON.stringify(get().SelectedDDOSPrice));
        localStorage.setItem("__OSPrice", JSON.stringify(get().OSPrice));
        localStorage.setItem("__DBPrice", JSON.stringify(get().DBPrice));
        localStorage.setItem("__totalCpuCore", JSON.stringify(get().totalCpuCore));
        localStorage.setItem("__selectedCpu", JSON.stringify(get().selectedCpu));
        localStorage.setItem("__selectedFirewall", JSON.stringify(get().selectedFirewall));
        localStorage.setItem("__selectedOS", JSON.stringify(get().selectedOS));
        localStorage.setItem("__selectedSubOS", JSON.stringify(get().selectedSubOS));
        localStorage.setItem("__selectedServer", JSON.stringify(get().selectedServer));
        localStorage.setItem("__basketCount", JSON.stringify(get().basketCount));
        localStorage.setItem("__controlPanelDetails", JSON.stringify(get().controlPanelDetails));
        localStorage.setItem("__configurationNote", JSON.stringify(get().configurationNote));
        localStorage.setItem("__configurationType", JSON.stringify(get().configurationType));
        localStorage.setItem("__coLocationBackupPrice", JSON.stringify(get().coLocationBackupPrice));
        localStorage.setItem("__selectedYear", JSON.stringify(get().selectedYear));
    }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_obj, "checkLocalStorage", function() {
        if (typeof localStorage.getItem("__products") !== "undefined" && localStorage.getItem("__products") !== null && localStorage.getItem("__products") !== "") set(function(state) {
            return {
                configurationTotal: JSON.parse(localStorage.getItem("__products"))
            };
        });
        if (typeof localStorage.getItem("__configuration") !== "undefined" && localStorage.getItem("__configuration") !== null && localStorage.getItem("__configuration") !== "") set(function(state) {
            return {
                configuration: JSON.parse(localStorage.getItem("__configuration"))
            };
        });
        if (typeof localStorage.getItem("__componentValues") !== "undefined" && localStorage.getItem("__componentValues") !== null && localStorage.getItem("__componentValues") !== "") set(function(state) {
            return {
                componentValues: JSON.parse(localStorage.getItem("__componentValues"))
            };
        });
        if (typeof localStorage.getItem("__selectedDisk1") !== "undefined" && localStorage.getItem("__selectedDisk1") !== null && localStorage.getItem("__selectedDisk1") !== "") set(function(state) {
            return {
                selectedDisk1: JSON.parse(localStorage.getItem("__selectedDisk1"))
            };
        });
        if (typeof localStorage.getItem("__selectedDisk2") !== "undefined" && localStorage.getItem("__selectedDisk2") !== null && localStorage.getItem("__selectedDisk2") !== "") set(function(state) {
            return {
                selectedDisk2: JSON.parse(localStorage.getItem("__selectedDisk2"))
            };
        });
        if (typeof localStorage.getItem("__backupStack") !== "undefined" && localStorage.getItem("__backupStack") !== null && localStorage.getItem("__backupStack") !== "") set(function(state) {
            return {
                backupStack: JSON.parse(localStorage.getItem("__backupStack"))
            };
        });
        if (typeof localStorage.getItem("__wafPrice") !== "undefined" && localStorage.getItem("__wafPrice") !== null && localStorage.getItem("__wafPrice") !== "") set(function(state) {
            return {
                wafPrice: JSON.parse(localStorage.getItem("__wafPrice"))
            };
        });
        if (typeof localStorage.getItem("__IPSPrice") !== "undefined" && localStorage.getItem("__IPSPrice") !== null && localStorage.getItem("__IPSPrice") !== "") set(function(state) {
            return {
                IPSPrice: JSON.parse(localStorage.getItem("__IPSPrice"))
            };
        });
        if (typeof localStorage.getItem("__DDOSPrice") !== "undefined" && localStorage.getItem("__DDOSPrice") !== null && localStorage.getItem("__DDOSPrice") !== "") set(function(state) {
            return {
                DDOSPrice: JSON.parse(localStorage.getItem("__DDOSPrice"))
            };
        });
        if (typeof localStorage.getItem("__defaultPaymentCycle") !== "undefined" && localStorage.getItem("__defaultPaymentCycle") !== null && localStorage.getItem("__defaultPaymentCycle") !== "") set(function(state) {
            return {
                defaultPaymentCycle: JSON.parse(localStorage.getItem("__defaultPaymentCycle"))
            };
        });
        if (typeof localStorage.getItem("__SelectedDDOSPrice") !== "undefined" && localStorage.getItem("__SelectedDDOSPrice") !== null && localStorage.getItem("__SelectedDDOSPrice") !== "") set(function(state) {
            return {
                SelectedDDOSPrice: JSON.parse(localStorage.getItem("__SelectedDDOSPrice"))
            };
        });
        if (typeof localStorage.getItem("__OSPrice") !== "undefined" && localStorage.getItem("__OSPrice") !== null && localStorage.getItem("__OSPrice") !== "") set(function(state) {
            return {
                OSPrice: JSON.parse(localStorage.getItem("__OSPrice"))
            };
        });
        if (typeof localStorage.getItem("__DBPrice") !== "undefined" && localStorage.getItem("__DBPrice") !== null && localStorage.getItem("__DBPrice") !== "") set(function(state) {
            return {
                DBPrice: JSON.parse(localStorage.getItem("__DBPrice"))
            };
        });
        if (typeof localStorage.getItem("__totalCpuCore") !== "undefined" && localStorage.getItem("__totalCpuCore") !== null && localStorage.getItem("__totalCpuCore") !== "") set(function(state) {
            return {
                totalCpuCore: JSON.parse(localStorage.getItem("__totalCpuCore"))
            };
        });
        if (typeof localStorage.getItem("__selectedCpu") !== "undefined" && localStorage.getItem("__selectedCpu") !== null && localStorage.getItem("__selectedCpu") !== "") set(function(state) {
            return {
                selectedCpu: JSON.parse(localStorage.getItem("__selectedCpu"))
            };
        });
        if (typeof localStorage.getItem("__selectedFirewall") !== "undefined" && localStorage.getItem("__selectedFirewall") !== null && localStorage.getItem("__selectedFirewall") !== "") set(function(state) {
            return {
                selectedFirewall: JSON.parse(localStorage.getItem("__selectedFirewall"))
            };
        });
        if (typeof localStorage.getItem("__selectedOS") !== "undefined" && localStorage.getItem("__selectedOS") !== null && localStorage.getItem("__selectedOS") !== "") set(function(state) {
            return {
                selectedOS: JSON.parse(localStorage.getItem("__selectedOS"))
            };
        });
        if (typeof localStorage.getItem("__selectedSubOS") !== "undefined" && localStorage.getItem("__selectedSubOS") !== null && localStorage.getItem("__selectedSubOS") !== "") set(function(state) {
            return {
                selectedSubOS: JSON.parse(localStorage.getItem("__selectedSubOS"))
            };
        });
        if (typeof localStorage.getItem("__selectedServer") !== "undefined" && localStorage.getItem("__selectedServer") !== null && localStorage.getItem("__selectedServer") !== "") set(function(state) {
            return {
                selectedServer: JSON.parse(localStorage.getItem("__selectedServer"))
            };
        });
        if (typeof localStorage.getItem("__basketCount") !== "undefined" && localStorage.getItem("__basketCount") !== null && localStorage.getItem("__basketCount") !== "") set(function(state) {
            return {
                basketCount: JSON.parse(localStorage.getItem("__basketCount"))
            };
        });
        if (typeof localStorage.getItem("__controlPanelDetails") !== "undefined" && localStorage.getItem("__controlPanelDetails") !== null && localStorage.getItem("__controlPanelDetails") !== "") set(function(state) {
            return {
                controlPanelDetails: JSON.parse(localStorage.getItem("__controlPanelDetails"))
            };
        });
        if (typeof localStorage.getItem("__configurationNote") !== "undefined" && localStorage.getItem("__configurationNote") !== null && localStorage.getItem("__configurationNote") !== "") set(function(state) {
            return {
                configurationNote: JSON.parse(localStorage.getItem("__configurationNote"))
            };
        });
        if (typeof localStorage.getItem("__configurationType") !== "undefined" && localStorage.getItem("__configurationType") !== null && localStorage.getItem("__configurationType") !== "") localStorage.getItem("__configurationType") !== "undefined" && set(function(state) {
            return {
                configurationType: JSON.parse(localStorage.getItem("__configurationType"))
            };
        });
        if (typeof localStorage.getItem("__coLocationBackupPrice") !== "undefined" && localStorage.getItem("__coLocationBackupPrice") !== null && localStorage.getItem("__coLocationBackupPrice") !== "") set(function(state) {
            return {
                coLocationBackupPrice: JSON.parse(localStorage.getItem("__coLocationBackupPrice"))
            };
        });
        if (typeof localStorage.getItem("__selectedYear") !== "undefined" && localStorage.getItem("__selectedYear") !== null && localStorage.getItem("__selectedYear") !== "") localStorage.getItem("__selectedYear") !== "0" && localStorage.getItem("__selectedYear") !== "undefined" && set(function(state) {
            return {
                selectedYear: JSON.parse(localStorage.getItem("__selectedYear"))
            };
        });
    }), _obj;
}));


/***/ })

}]);